(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory()
    : typeof define === 'function' && define.amd ? define(factory)
      : (global.wangEditor = factory());
}(this, (() => {
 
 const i18n = require('../i18n').default
 const lang = localStorage.getItem('ark-ui-bcl-lang') || 'zh'
  /*
    poly-fill
*/

  let polyfill = function () {
    // Object.assign
    if (typeof Object.assign !== 'function') {
      Object.assign = function (target, varArgs) {
        // .length of function is 2
        if (target == null) {
          // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }

        let to = Object(target);

        for (let index = 1; index < arguments.length; index++) {
          let nextSource = arguments[index];

          if (nextSource != null) {
            // Skip over if undefined or null
            for (let nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      };
    }

    // IE 中兼容 Element.prototype.matches
    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
        let matches = (this.document || this.ownerDocument).querySelectorAll(s);
                var i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1;
      };
    }
  };

  /*
    DOM 操作 API
*/

  // 根据 html 代码片段创建 dom 对象
  function createElemByHTML(html) {
    let div = void 0;
    div = document.createElement('div');
    div.innerHTML = html;
    return div.children;
  }

  // 是否是 DOM List
  function isDOMList(selector) {
    if (!selector) {
      return false;
    }
    if (selector instanceof HTMLCollection || selector instanceof NodeList) {
      return true;
    }
    return false;
  }

  // 封装 document.querySelectorAll
  function querySelectorAll(selector) {
    var result = document.querySelectorAll(selector);
    if (isDOMList(result)) {
        return result;
    } 
        return [result];
    
}

  // 记录所有的事件绑定
  let eventList = [];

  // 创建构造函数
  function DomElement(selector) {
    if (!selector) {
      return;
    }

    // selector 本来就是 DomElement 对象，直接返回
    if (selector instanceof DomElement) {
      return selector;
    }

    this.selector = selector;
    let nodeType = selector.nodeType;

    // 根据 selector 得出的结果（如 DOM，DOM List）
    let selectorResult = [];
    if (nodeType === 9) {
      // document 节点
      selectorResult = [selector];
    } else if (nodeType === 1) {
      // 单个 DOM 节点
      selectorResult = [selector];
    } else if (isDOMList(selector) || selector instanceof Array) {
      // DOM List 或者数组
      selectorResult = selector;
    } else if (typeof selector === 'string') {
      // 字符串
      selector = selector.replace('/\n/mg', '').trim();
      if (selector.indexOf('<') === 0) {
        // 如 <div>
        selectorResult = createElemByHTML(selector);
      } else {
        // 如 #id .class
        selectorResult = querySelectorAll(selector);
      }
    }

    let length = selectorResult.length;
    if (!length) {
      // 空数组
      return this;
    }

    // 加入 DOM 节点
    let i = void 0;
    for (i = 0; i < length; i++) {
      this[i] = selectorResult[i];
    }
    this.length = length;
  }

  // 修改原型
  DomElement.prototype = {
    constructor: DomElement,

    // 类数组，forEach
    forEach: function forEach(fn) {
      let i = void 0;
      for (i = 0; i < this.length; i++) {
        let elem = this[i];
        let result = fn.call(elem, elem, i);
        if (result === false) {
          break;
        }
      }
      return this;
    },

    // clone
    clone: function clone(deep) {
      let cloneList = [];
      this.forEach((elem) => {
            cloneList.push(elem.cloneNode(!!deep));
        });
      return $(cloneList);
    },

    // 获取第几个元素
    get: function get(index) {
      let length = this.length;
      if (index >= length) {
        index %= length;
      }
      return $(this[index]);
    },

    // 第一个
    first: function first() {
      return this.get(0);
    },

    // 最后一个
    last: function last() {
      let length = this.length;
      return this.get(length - 1);
    },

    // 绑定事件
    on: function on(type, selector, fn) {
      // selector 不为空，证明绑定事件要加代理
      if (!fn) {
        fn = selector;
        selector = null;
      }

      // type 是否有多个
      let types = [];
      types = type.split(/\s+/);

      return this.forEach((elem) => {
            types.forEach(function (type) {
                if (!type) {
                    return;
                }

                // 记录下，方便后面解绑
                eventList.push({
                    elem: elem,
                    type: type,
                    fn: fn
                });

                if (!selector) {
                    // 无代理
                    elem.addEventListener(type, fn);
                    return;
                }

                // 有代理
                elem.addEventListener(type, function (e) {
                    var target = e.target;
                    if (target.matches(selector)) {
                        fn.call(target, e);
                    }
                });
            });
        });
    },

    // 取消事件绑定
    off: function off(type, fn) {
      return this.forEach((elem) => {
            elem.removeEventListener(type, fn);
        });
    },

    // 获取/设置 属性
    attr: function attr(key, val) {
        if (val == null) {
            // 获取值
            return this[0].getAttribute(key);
        } 
            // 设置值
            return this.forEach(function (elem) {
                elem.setAttribute(key, val);
            });
        
    },

    // 添加 class
    addClass: function addClass(className) {
      if (!className) {
        return this;
      }
      return this.forEach((elem) => {
            var arr = void 0;
            if (elem.className) {
                // 解析当前 className 转换为数组
                arr = elem.className.split(/\s/);
                arr = arr.filter(function (item) {
                    return !!item.trim();
                });
                // 添加 class
                if (arr.indexOf(className) < 0) {
                    arr.push(className);
                }
                // 修改 elem.class
                elem.className = arr.join(' ');
            } else {
                elem.className = className;
            }
        });
    },

    // 删除 class
    removeClass: function removeClass(className) {
      if (!className) {
        return this;
      }
      return this.forEach((elem) => {
            var arr = void 0;
            if (elem.className) {
                // 解析当前 className 转换为数组
                arr = elem.className.split(/\s/);
                arr = arr.filter(function (item) {
                    item = item.trim();
                    // 删除 class
                    if (!item || item === className) {
                        return false;
                    }
                    return true;
                });
                // 修改 elem.class
                elem.className = arr.join(' ');
            }
        });
    },

    // 修改 css
    css: function css(key, val) {
      let currentStyle = `${key  }:${  val  };`;
      return this.forEach((elem) => {
            var style = (elem.getAttribute('style') || '').trim();
            var styleArr = void 0,
                resultArr = [];
            if (style) {
                // 将 style 按照 ; 拆分为数组
                styleArr = style.split(';');
                styleArr.forEach(function (item) {
                    // 对每项样式，按照 : 拆分为 key 和 value
                    var arr = item.split(':').map(function (i) {
                        return i.trim();
                    });
                    if (arr.length === 2) {
                        resultArr.push(arr[0] + ':' + arr[1]);
                    }
                });
                // 替换或者新增
                resultArr = resultArr.map(function (item) {
                    if (item.indexOf(key) === 0) {
                        return currentStyle;
                    } else {
                        return item;
                    }
                });
                if (resultArr.indexOf(currentStyle) < 0) {
                    resultArr.push(currentStyle);
                }
                // 结果
                elem.setAttribute('style', resultArr.join('; '));
            } else {
                // style 无值
                elem.setAttribute('style', currentStyle);
            }
        });
    },

    // 显示
    show: function show() {
      return this.css('display', 'block');
    },

    // 隐藏
    hide: function hide() {
      return this.css('display', 'none');
    },

    // 获取子节点
    children: function children() {
      let elem = this[0];
      if (!elem) {
        return null;
      }

      return $(elem.children);
    },

    // 获取子节点（包括文本节点）
    childNodes: function childNodes() {
      let elem = this[0];
      if (!elem) {
        return null;
      }

      return $(elem.childNodes);
    },

    // 增加子节点
    append: function append($children) {
      return this.forEach((elem) => {
            $children.forEach(function (child) {
                elem.appendChild(child);
            });
        });
    },

    // 移除当前节点
    remove: function remove() {
      return this.forEach((elem) => {
            if (elem.remove) {
                elem.remove();
            } else {
                var parent = elem.parentElement;
                parent && parent.removeChild(elem);
            }
        });
    },

    // 是否包含某个子节点
    isContain: function isContain($child) {
      let elem = this[0];
      let child = $child[0];
      return elem.contains(child);
    },

    // 尺寸数据
    getSizeData: function getSizeData() {
      let elem = this[0];
      return elem.getBoundingClientRect(); // 可得到 bottom height left right top width 的数据
    },

    // 封装 nodeName
    getNodeName: function getNodeName() {
      let elem = this[0];
      return elem.nodeName;
    },

    // 从当前元素查找
    find: function find(selector) {
      let elem = this[0];
      return $(elem.querySelectorAll(selector));
    },

    // 获取当前元素的 text
    text: function text(val) {
        if (!val) {
            // 获取 text
            var elem = this[0];
            return elem.innerHTML.replace(/<.*?>/g, function () {
                return '';
            });
        } 
            // 设置 text
            return this.forEach(function (elem) {
                elem.innerHTML = val;
            });
        
    },

    // 获取 html
    html: function html(value) {
        var elem = this[0];
        if (value == null) {
            return elem.innerHTML;
        } 
            elem.innerHTML = value;
            return this;
        
    },

    // 获取 value
    val: function val() {
      let elem = this[0];
      return elem.value.trim();
    },

    // focus
    focus: function focus() {
      return this.forEach((elem) => {
            elem.focus();
        });
    },

    // parent
    parent: function parent() {
      let elem = this[0];
      return $(elem.parentElement);
    },

    // parentUntil 找到符合 selector 的父节点
    parentUntil: function parentUntil(selector, _currentElem) {
      let results = document.querySelectorAll(selector);
      let length = results.length;
      if (!length) {
        // 传入的 selector 无效
        return null;
      }

      let elem = _currentElem || this[0];
      if (elem.nodeName === 'BODY') {
        return null;
      }

      let parent = elem.parentElement;
      let i = void 0;
      for (i = 0; i < length; i++) {
        if (parent === results[i]) {
          // 找到，并返回
          return $(parent);
        }
      }

      // 继续查找
      return this.parentUntil(selector, parent);
    },

    // 判断两个 elem 是否相等
    equal: function equal($elem) {
        if ($elem.nodeType === 1) {
            return this[0] === $elem;
        } 
            return this[0] === $elem[0];
        
    },

    // 将该元素插入到某个元素前面
    insertBefore: function insertBefore(selector) {
      let $referenceNode = $(selector);
      let referenceNode = $referenceNode[0];
      if (!referenceNode) {
        return this;
      }
      return this.forEach((elem) => {
            var parent = referenceNode.parentNode;
            parent.insertBefore(elem, referenceNode);
        });
    },

    // 将该元素插入到某个元素后面
    insertAfter: function insertAfter(selector) {
      let $referenceNode = $(selector);
      let referenceNode = $referenceNode[0];
      if (!referenceNode) {
        return this;
      }
      return this.forEach((elem) => {
            var parent = referenceNode.parentNode;
            if (parent.lastChild === referenceNode) {
                // 最后一个元素
                parent.appendChild(elem);
            } else {
                // 不是最后一个元素
                parent.insertBefore(elem, referenceNode.nextSibling);
            }
        });
    }
  };

  // new 一个对象
  function $(selector) {
    return new DomElement(selector);
  }

  // 解绑所有事件，用于销毁编辑器
  $.offAll = function () {
    eventList.forEach((item) => {
        var elem = item.elem;
        var type = item.type;
        var fn = item.fn;
        // 解绑
        elem.removeEventListener(type, fn);
    });
  };

  /*
    配置信息
*/

  let config = {

    // 默认菜单配置
    menus: ['head', 'bold', 'italic', 'underline', 'strikeThrough', 'foreColor', 'backColor', 'link', 'list', 'justify', 'quote', 'emoticon', 'image', 'table', 'video', 'code', 'undo', 'redo'],

    colors: ['#000000', '#eeece0', '#1c487f', '#4d80bf', '#c24f4a', '#8baa4a', '#7b5ba1', '#46acc8', '#f9963b', '#ffffff'],

    // 语言配置
    lang: {
        // '设置标题': 'title',
        '正文': lang === 'zh'? '正文': 'text',
        '链接文字': lang === 'zh'? '链接文字': 'link text',
        // '链接': 'link',
        '插入': lang === 'zh'? '插入' : 'insert',
        // '创建': 'init',
        '靠左': lang === 'zh'? '靠左' : 'left',
        '居中': lang === 'zh'? '居中' : 'center',
        '靠右': lang === 'zh'? '靠右' : 'right',
        '图片链接': lang === 'zh'? '图片链接' : 'image link',
        '行': lang === 'zh'? '行' : 'rows',
        '列': lang === 'zh'? '列' : 'columns',
        '的': lang === 'zh'? '的' : ' of ',
        '表格': lang === 'zh'? '表格' : 'table',
        '创建': lang === 'zh'? '创建' : 'create',
    },

    // 表情
    emotions: [{
      // tab 的标题
      title: i18n.t('tips.default'),
      // type -> 'emoji' / 'image'
      type: 'image',
      // content -> 数组
      content: [{
        alt: '[坏笑]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/50/pcmoren_huaixiao_org.png'
      }, {
        alt: '[舔屏]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/40/pcmoren_tian_org.png'
      }, {
        alt: '[污]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/3c/pcmoren_wu_org.png'
      }, {
        alt: '[允悲]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/2c/moren_yunbei_org.png'
      }, {
        alt: '[笑而不语]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/3a/moren_xiaoerbuyu_org.png'
      }, {
        alt: '[费解]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/3c/moren_feijie_org.png'
      }, {
        alt: '[憧憬]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/37/moren_chongjing_org.png'
      }, {
        alt: '[并不简单]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/fc/moren_bbjdnew_org.png'
      }, {
        alt: '[微笑]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/5c/huanglianwx_org.gif'
      }, {
        alt: '[酷]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/8a/pcmoren_cool2017_org.png'
      }, {
        alt: '[嘻嘻]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/0b/tootha_org.gif'
      }, {
        alt: '[哈哈]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/6a/laugh.gif'
      }, {
        alt: '[可爱]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/14/tza_org.gif'
      }, {
        alt: '[可怜]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/af/kl_org.gif'
      }, {
        alt: '[挖鼻]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/0b/wabi_org.gif'
      }, {
        alt: '[吃惊]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/f4/cj_org.gif'
      }, {
        alt: '[害羞]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/6e/shamea_org.gif'
      }, {
        alt: '[挤眼]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/c3/zy_org.gif'
      }, {
        alt: '[闭嘴]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/29/bz_org.gif'
      }, {
        alt: '[鄙视]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/71/bs2_org.gif'
      }, {
        alt: '[爱你]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/6d/lovea_org.gif'
      }, {
        alt: '[泪]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/9d/sada_org.gif'
      }, {
        alt: '[偷笑]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/19/heia_org.gif'
      }, {
        alt: '[亲亲]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/8f/qq_org.gif'
      }, {
        alt: '[生病]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/b6/sb_org.gif'
      }, {
        alt: '[太开心]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/58/mb_org.gif'
      }, {
        alt: '[白眼]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/d9/landeln_org.gif'
      }, {
        alt: '[右哼哼]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/98/yhh_org.gif'
      }, {
        alt: '[左哼哼]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/6d/zhh_org.gif'
      }, {
        alt: '[嘘]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/a6/x_org.gif'
      }, {
        alt: '[衰]',
        src: 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/af/cry.gif'
      }]
    }, {
      // tab 的标题
      title: i18n.t('tips.sina'),
      // type -> 'emoji' / 'image'
      type: 'image',
      // content -> 数组
      content: [{
        src: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/7a/shenshou_thumb.gif',
        alt: '[草泥马]'
      }, {
        src: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/60/horse2_thumb.gif',
        alt: '[神马]'
      }, {
        src: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/bc/fuyun_thumb.gif',
        alt: '[浮云]'
      }, {
        src: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/c9/geili_thumb.gif',
        alt: '[给力]'
      }, {
        src: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/f2/wg_thumb.gif',
        alt: '[围观]'
      }, {
        src: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/70/vw_thumb.gif',
        alt: '[威武]'
      }, {
        src: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/6e/panda_thumb.gif',
        alt: '[熊猫]'
      }, {
        src: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/81/rabbit_thumb.gif',
        alt: '[兔子]'
      }, {
        src: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/bc/otm_thumb.gif',
        alt: '[奥特曼]'
      }, {
        src: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/15/j_thumb.gif',
        alt: '[囧]'
      }, {
        src: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/89/hufen_thumb.gif',
        alt: '[互粉]'
      }, {
        src: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/c4/liwu_thumb.gif',
        alt: '[礼物]'
      }]
    }, {
      // tab 的标题
      title: 'emoji',
      // type -> 'emoji' / 'image'
      type: 'emoji',
      // content -> 数组
      content: '😀 😃 😄 😁 😆 😅 😂 😊 😇 🙂 🙃 😉 😌 😍 😘 😗 😙 😚 😋 😜 😝 😛 🤑 🤗 🤓 😎 😏 😒 😞 😔 😟 😕 🙁  😣 😖 😫 😩 😤 😠 😡 😶 😐 😑 😯 😦 😧 😮 😲 😵 😳 😱 😨 😰 😢 😥 😭 😓 😪 😴 🙄 🤔 😬 🤐'.split(/\s/)
    }],

    // 编辑区域的 z-index
    zIndex: 10000,

    // 是否开启 debug 模式（debug 模式下错误会 throw error 形式抛出）
    debug: false,

    // 插入链接时候的格式校验
    linkCheck: function linkCheck(text, link) {
      // text 是插入的文字
      // link 是插入的链接
      return true; // 返回 true 即表示成功
      // return '校验失败' // 返回字符串即表示失败的提示信息
    },

    // 插入网络图片的校验
    linkImgCheck: function linkImgCheck(src) {
      // src 即图片的地址
      return true; // 返回 true 即表示成功
      // return '校验失败'  // 返回字符串即表示失败的提示信息
    },

    // 粘贴过滤样式，默认开启
    pasteFilterStyle: true,

    // 对粘贴的文字进行自定义处理，返回处理后的结果。编辑器会将处理后的结果粘贴到编辑区域中。
    // IE 暂时不支持
    pasteTextHandle: function pasteTextHandle(content) {
      // content 即粘贴过来的内容（html 或 纯文本），可进行自定义处理然后返回
      return content;
    },

    // onchange 事件
    // onchange: function (html) {
    //     // html 即变化之后的内容
    //     console.log(html)
    // },

    // 是否显示添加网络图片的 tab
    showLinkImg: true,

    // 插入网络图片的回调
    linkImgCallback: function linkImgCallback(url) {
      // console.log(url)  // url 即插入图片的地址
    },

    // 默认上传图片 max size: 5M
    uploadImgMaxSize: 5 * 1024 * 1024,

    // 配置一次最多上传几个图片
    // uploadImgMaxLength: 5,

    // 上传图片，是否显示 base64 格式
    uploadImgShowBase64: false,

    // 上传图片，server 地址（如果有值，则 base64 格式的配置则失效）
    // uploadImgServer: '/upload',

    // 自定义配置 filename
    uploadFileName: '',

    // 上传图片的自定义参数
    uploadImgParams: {
      // token: 'abcdef12345'
    },

    // 上传图片的自定义header
    uploadImgHeaders: {
      // 'Accept': 'text/x-json'
    },

    // 配置 XHR withCredentials
    withCredentials: false,

    // 自定义上传图片超时时间 ms
    uploadImgTimeout: 10000,

    // 上传图片 hook
    uploadImgHooks: {
      // customInsert: function (insertLinkImg, result, editor) {
      //     console.log('customInsert')
      //     // 图片上传并返回结果，自定义插入图片的事件，而不是编辑器自动插入图片
      //     const data = result.data1 || []
      //     data.forEach(link => {
      //         insertLinkImg(link)
      //     })
      // },
      before: function before(xhr, editor, files) {
        // 图片上传之前触发

        // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
        // return {
        //     prevent: true,
        //     msg: '放弃上传'
        // }
      },
      success: function success(xhr, editor, result) {
        // 图片上传并返回结果，图片插入成功之后触发
      },
      fail: function fail(xhr, editor, result) {
        // 图片上传并返回结果，但图片插入错误时触发
      },
      error: function error(xhr, editor) {
        // 图片上传出错时触发
      },
      timeout: function timeout(xhr, editor) {
        // 图片上传超时时触发
      }
    },

    // 是否上传七牛云，默认为 false
    qiniu: false

  };

  /*
    工具
*/

  // 和 UA 相关的属性
  let UA = {
    _ua: navigator.userAgent,

    // 是否 webkit
    isWebkit: function isWebkit() {
      let reg = /webkit/i;
      return reg.test(this._ua);
    },

    // 是否 IE
    isIE: function isIE() {
      return 'ActiveXObject' in window;
    }
  };

  // 遍历对象
  function objForEach(obj, fn) {
    let key = void 0;
        var result = void 0;
    for (key in obj) {
      if (obj.hasOwnProperty(key)) {
        result = fn.call(obj, key, obj[key]);
        if (result === false) {
          break;
        }
      }
    }
  }

  // 遍历类数组
  function arrForEach(fakeArr, fn) {
    let i = void 0;
        var item = void 0;
        var result = void 0;
    let length = fakeArr.length || 0;
    for (i = 0; i < length; i++) {
      item = fakeArr[i];
      result = fn.call(fakeArr, item, i);
      if (result === false) {
        break;
      }
    }
  }

  // 获取随机数
  function getRandom(prefix) {
    return prefix + Math.random().toString().slice(2);
  }

  // 替换 html 特殊字符
  function replaceHtmlSymbol(html) {
    if (html == null) {
      return '';
    }
    return html.replace(/</gm, '&lt;').replace(/>/gm, '&gt;').replace(/"/gm, '&quot;');
  }

  // 返回百分比的格式

  /*
    bold-menu
*/
  // 构造函数
  function Bold(editor) {
    this.editor = editor;
    this.$elem = $('<div class="w-e-menu">\n            <i class="w-e-icon-bold"><i/>\n        </div>');
    this.type = 'click';

    // 当前是否 active 状态
    this._active = false;
  }

  // 原型
  Bold.prototype = {
    constructor: Bold,

    // 点击事件
    onClick: function onClick(e) {
      // 点击菜单将触发这里

      let editor = this.editor;
      let isSeleEmpty = editor.selection.isSelectionEmpty();

      if (isSeleEmpty) {
        // 选区是空的，插入并选中一个“空白”
        editor.selection.createEmptyRange();
      }

      // 执行 bold 命令
      editor.cmd.do('bold');

      if (isSeleEmpty) {
        // 需要将选取折叠起来
        editor.selection.collapseRange();
        editor.selection.restoreSelection();
      }
    },

    // 试图改变 active 状态
    tryChangeActive: function tryChangeActive(e) {
      let editor = this.editor;
      let $elem = this.$elem;
      if (editor.cmd.queryCommandState('bold')) {
        this._active = true;
        $elem.addClass('w-e-active');
      } else {
        this._active = false;
        $elem.removeClass('w-e-active');
      }
    }
  };

  /*
    替换多语言
 */

  let replaceLang = function (editor, str) {
    let langArgs = editor.config.langArgs || [];
    let result = str;

    langArgs.forEach((item) => {
        var reg = item.reg;
        var val = item.val;

        if (reg.test(result)) {
            result = result.replace(reg, function () {
                return val;
            });
        }
    });

    return result;
  };

  /*
    droplist
*/
  let _emptyFn = function _emptyFn() {};

  // 构造函数
  function DropList(menu, opt) {
    let _this = this;

    // droplist 所依附的菜单
    let editor = menu.editor;
    this.menu = menu;
    this.opt = opt;
    // 容器
    let $container = $('<div class="w-e-droplist"></div>');

    // 标题
    let $title = opt.$title;
    let titleHtml = void 0;
    if ($title) {
      // 替换多语言
      titleHtml = $title.html();
      titleHtml = replaceLang(editor, titleHtml);
      $title.html(titleHtml);

      $title.addClass('w-e-dp-title');
      $container.append($title);
    }

    let list = opt.list || [];
    let type = opt.type || 'list'; // 'list' 列表形式（如“标题”菜单） / 'inline-block' 块状形式（如“颜色”菜单）
    let onClick = opt.onClick || _emptyFn;

    // 加入 DOM 并绑定事件
    let $list = $(`<ul class="${  type === 'list' ? 'w-e-list' : 'w-e-block'  }"></ul>`);
    $container.append($list);
    list.forEach((item) => {
        var $elem = item.$elem;

        // 替换多语言
        var elemHtml = $elem.html();
        elemHtml = replaceLang(editor, elemHtml);
        $elem.html(elemHtml);

        var value = item.value;
        var $li = $('<li class="w-e-item"></li>');
        if ($elem) {
            $li.append($elem);
            $list.append($li);
            $elem.on('click', function (e) {
                onClick(value);

                // 隐藏
                _this.hideTimeoutId = setTimeout(function () {
                    _this.hide();
                }, 0);
            });
        }
    });

    // 绑定隐藏事件
    $container.on('mouseleave', (e) => {
        _this.hideTimeoutId = setTimeout(function () {
            _this.hide();
        }, 0);
    });

    // 记录属性
    this.$container = $container;

    // 基本属性
    this._rendered = false;
    this._show = false;
  }

  // 原型
  DropList.prototype = {
    constructor: DropList,

    // 显示（插入DOM）
    show: function show() {
      if (this.hideTimeoutId) {
        // 清除之前的定时隐藏
        clearTimeout(this.hideTimeoutId);
      }

      let menu = this.menu;
      let $menuELem = menu.$elem;
      let $container = this.$container;
      if (this._show) {
        return;
      }
      if (this._rendered) {
        // 显示
        $container.show();
      } else {
        // 加入 DOM 之前先定位位置
        let menuHeight = $menuELem.getSizeData().height || 0;
        let width = this.opt.width || 100; // 默认为 100
        $container.css('margin-top', `${menuHeight  }px`).css('width', `${width  }px`);

        // 加入到 DOM
        $menuELem.append($container);
        this._rendered = true;
      }

      // 修改属性
      this._show = true;
    },

    // 隐藏（移除DOM）
    hide: function hide() {
      if (this.showTimeoutId) {
        // 清除之前的定时显示
        clearTimeout(this.showTimeoutId);
      }

      let $container = this.$container;
      if (!this._show) {
        return;
      }
      // 隐藏并需改属性
      $container.hide();
      this._show = false;
    }
  };

  /*
    menu - header
*/
  // 构造函数
  function Head(editor) {
    let _this = this;

    this.editor = editor;
    this.$elem = $('<div class="w-e-menu"><i class="w-e-icon-header"><i/></div>');
    this.type = 'droplist';

    // 当前是否 active 状态
    this._active = false;

    // 初始化 droplist
    this.droplist = new DropList(this, {
      width: 100,
      $title: $(`<p>${i18n.t('wangEditor.setTitle')}</p>`),
      type: 'list', // droplist 以列表形式展示
      list: [{ $elem: $('<h1>H1</h1>'), value: '<h1>' }, { $elem: $('<h2>H2</h2>'), value: '<h2>' }, { $elem: $('<h3>H3</h3>'), value: '<h3>' }, { $elem: $('<h4>H4</h4>'), value: '<h4>' }, { $elem: $('<h5>H5</h5>'), value: '<h5>' }, { $elem: $('<p>正文</p>'), value: '<p>' }],
      onClick: function onClick(value) {
        // 注意 this 是指向当前的 Head 对象
        _this._command(value);
      }
    });
  }

  // 原型
  Head.prototype = {
    constructor: Head,

    // 执行命令
    _command: function _command(value) {
      let editor = this.editor;

      let $selectionElem = editor.selection.getSelectionContainerElem();
      if (editor.$textElem.equal($selectionElem)) {
        // 不能选中多行来设置标题，否则会出现问题
        // 例如选中的是 <p>xxx</p><p>yyy</p> 来设置标题，设置之后会成为 <h1>xxx<br>yyy</h1> 不符合预期
        return;
      }

      editor.cmd.do('formatBlock', value);
    },

    // 试图改变 active 状态
    tryChangeActive: function tryChangeActive(e) {
      let editor = this.editor;
      let $elem = this.$elem;
      let reg = /^h/i;
      let cmdValue = editor.cmd.queryCommandValue('formatBlock');
      if (reg.test(cmdValue)) {
        this._active = true;
        $elem.addClass('w-e-active');
      } else {
        this._active = false;
        $elem.removeClass('w-e-active');
      }
    }
  };

  /*
    panel
*/

  let emptyFn = function emptyFn() {};

  // 记录已经显示 panel 的菜单
  let _isCreatedPanelMenus = [];

  // 构造函数
  function Panel(menu, opt) {
    this.menu = menu;
    this.opt = opt;
  }

  // 原型
  Panel.prototype = {
    constructor: Panel,

    // 显示（插入DOM）
    show: function show() {
      let _this = this;

      let menu = this.menu;
      if (_isCreatedPanelMenus.indexOf(menu) >= 0) {
        // 该菜单已经创建了 panel 不能再创建
        return;
      }

      let editor = menu.editor;
      let $body = $('body');
      let $textContainerElem = editor.$textContainerElem;
      let opt = this.opt;

      // panel 的容器
      let $container = $('<div class="w-e-panel-container"></div>');
      let width = opt.width || 300; // 默认 300px
      $container.css('width', `${width  }px`).css('margin-left', `${(0 - width) / 2  }px`);

      // 添加关闭按钮
      let $closeBtn = $('<i class="w-e-icon-close w-e-panel-close"></i>');
      $container.append($closeBtn);
      $closeBtn.on('click', () => {
            _this.hide();
        });

      // 准备 tabs 容器
      let $tabTitleContainer = $('<ul class="w-e-panel-tab-title"></ul>');
      let $tabContentContainer = $('<div class="w-e-panel-tab-content"></div>');
      $container.append($tabTitleContainer).append($tabContentContainer);

      // 设置高度
      let height = opt.height;
      if (height) {
        $tabContentContainer.css('height', `${height  }px`).css('overflow-y', 'auto');
      }

      // tabs
      let tabs = opt.tabs || [];
      let tabTitleArr = [];
      let tabContentArr = [];
      tabs.forEach((tab, tabIndex) => {
            if (!tab) {
                return;
            }
            var title = tab.title || '';
            var tpl = tab.tpl || '';

            // 替换多语言
            title = replaceLang(editor, title);
            tpl = replaceLang(editor, tpl);

            // 添加到 DOM
            var $title = $('<li class="w-e-item">' + title + '</li>');
            $tabTitleContainer.append($title);
            var $content = $(tpl);
            $tabContentContainer.append($content);

            // 记录到内存
            $title._index = tabIndex;
            tabTitleArr.push($title);
            tabContentArr.push($content);

            // 设置 active 项
            if (tabIndex === 0) {
                $title._active = true;
                $title.addClass('w-e-active');
            } else {
                $content.hide();
            }

            // 绑定 tab 的事件
            $title.on('click', function (e) {
                if ($title._active) {
                    return;
                }
                // 隐藏所有的 tab
                tabTitleArr.forEach(function ($title) {
                    $title._active = false;
                    $title.removeClass('w-e-active');
                });
                tabContentArr.forEach(function ($content) {
                    $content.hide();
                });

                // 显示当前的 tab
                $title._active = true;
                $title.addClass('w-e-active');
                $content.show();
            });
        });

      // 绑定关闭事件
      $container.on('click', (e) => {
            // 点击时阻止冒泡
            e.stopPropagation();
        });
      $body.on('click', (e) => {
            _this.hide();
        });

      // 添加到 DOM
      $textContainerElem.append($container);

      // 绑定 opt 的事件，只有添加到 DOM 之后才能绑定成功
      tabs.forEach((tab, index) => {
            if (!tab) {
                return;
            }
            var events = tab.events || [];
            events.forEach(function (event) {
                var selector = event.selector;
                var type = event.type;
                var fn = event.fn || emptyFn;
                var $content = tabContentArr[index];
                $content.find(selector).on(type, function (e) {
                    e.stopPropagation();
                    var needToHide = fn(e);
                    // 执行完事件之后，是否要关闭 panel
                    if (needToHide) {
                        _this.hide();
                    }
                });
            });
        });

      // focus 第一个 elem
      let $inputs = $container.find('input[type=text],textarea');
      if ($inputs.length) {
        $inputs.get(0).focus();
      }

      // 添加到属性
      this.$container = $container;

      // 隐藏其他 panel
      this._hideOtherPanels();
      // 记录该 menu 已经创建了 panel
      _isCreatedPanelMenus.push(menu);
    },

    // 隐藏（移除DOM）
    hide: function hide() {
      let menu = this.menu;
      let $container = this.$container;
      if ($container) {
        $container.remove();
      }

      // 将该 menu 记录中移除
      _isCreatedPanelMenus = _isCreatedPanelMenus.filter((item) => {
            if (item === menu) {
                return false;
            } else {
                return true;
            }
        });
    },

    // 一个 panel 展示时，隐藏其他 panel
    _hideOtherPanels: function _hideOtherPanels() {
      if (!_isCreatedPanelMenus.length) {
        return;
      }
      _isCreatedPanelMenus.forEach((menu) => {
            var panel = menu.panel || {};
            if (panel.hide) {
                panel.hide();
            }
        });
    }
  };

  /*
    menu - link
*/
  // 构造函数
  function Link(editor) {
    this.editor = editor;
    this.$elem = $('<div class="w-e-menu"><i class="w-e-icon-link"><i/></div>');
    this.type = 'panel';

    // 当前是否 active 状态
    this._active = false;
  }

  // 原型
  Link.prototype = {
    constructor: Link,

    // 点击事件
    onClick: function onClick(e) {
      let editor = this.editor;
      let $linkelem = void 0;

      if (this._active) {
        // 当前选区在链接里面
        $linkelem = editor.selection.getSelectionContainerElem();
        if (!$linkelem) {
          return;
        }
        // 将该元素都包含在选取之内，以便后面整体替换
        editor.selection.createRangeByElem($linkelem);
        editor.selection.restoreSelection();
        // 显示 panel
        this._createPanel($linkelem.text(), $linkelem.attr('href'));
      } else {
        // 当前选区不在链接里面
        if (editor.selection.isSelectionEmpty()) {
          // 选区是空的，未选中内容
          this._createPanel('', '');
        } else {
          // 选中内容了
          this._createPanel(editor.selection.getSelectionText(), '');
        }
      }
    },

    // 创建 panel
    _createPanel: function _createPanel(text, link) {
      let _this = this;

      // panel 中需要用到的id
      let inputLinkId = getRandom('input-link');
      let inputTextId = getRandom('input-text');
      let btnOkId = getRandom('btn-ok');
      let btnDelId = getRandom('btn-del');

      // 是否显示“删除链接”
      let delBtnDisplay = this._active ? 'inline-block' : 'none';

      // 初始化并显示 panel
      let panel = new Panel(this, {
        width: 300,
        // panel 中可包含多个 tab
        tabs: [{
          // tab 的标题
          title: i18n.t('tips.link'),
          // 模板
          tpl: `<div>\n                            <input id="${  inputTextId  }" type="text" class="block" value="${  text  }" placeholder="\u94FE\u63A5\u6587\u5B57"/></td>\n                            <input id="${  inputLinkId  }" type="text" class="block" value="${  link  }" placeholder="http://..."/></td>\n                            <div class="w-e-button-container">\n                                <button id="${  btnOkId  }" class="right">\u63D2\u5165</button>\n                                <button id="${  btnDelId  }" class="gray right" style="display:${  delBtnDisplay  }">\u5220\u9664\u94FE\u63A5</button>\n                            </div>\n                        </div>`,
          // 事件绑定
          events: [
            // 插入链接
            {
              selector: `#${  btnOkId}`,
              type: 'click',
              fn: function fn() {
                // 执行插入链接
                let $link = $(`#${  inputLinkId}`);
                let $text = $(`#${  inputTextId}`);
                let link = $link.val();
                let text = $text.val();
                _this._insertLink(text, link);

                // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
                return true;
              }
            },
            // 删除链接
            {
              selector: `#${  btnDelId}`,
              type: 'click',
              fn: function fn() {
                // 执行删除链接
                _this._delLink();

                // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
                return true;
              }
            }]
        } // tab end
        ] // tabs end
      });

      // 显示 panel
      panel.show();

      // 记录属性
      this.panel = panel;
    },

    // 删除当前链接
    _delLink: function _delLink() {
      if (!this._active) {
        return;
      }
      let editor = this.editor;
      let $selectionELem = editor.selection.getSelectionContainerElem();
      if (!$selectionELem) {
        return;
      }
      let selectionText = editor.selection.getSelectionText();
      editor.cmd.do('insertHTML', `<span>${  selectionText  }</span>`);
    },

    // 插入链接
    _insertLink: function _insertLink(text, link) {
      if (!text || !link) {
        return;
      }
      let editor = this.editor;
      let config = editor.config;
      let linkCheck = config.linkCheck;
      let checkResult = true; // 默认为 true
      if (linkCheck && typeof linkCheck === 'function') {
        checkResult = linkCheck(text, link);
      }
      if (checkResult === true) {
        editor.cmd.do('insertHTML', `<a href="${  link  }" target="_blank">${  text  }</a>`);
      } else {
        alert(checkResult);
      }
    },

    // 试图改变 active 状态
    tryChangeActive: function tryChangeActive(e) {
      let editor = this.editor;
      let $elem = this.$elem;
      let $selectionELem = editor.selection.getSelectionContainerElem();
      if (!$selectionELem) {
        return;
      }
      if ($selectionELem.getNodeName() === 'A') {
        this._active = true;
        $elem.addClass('w-e-active');
      } else {
        this._active = false;
        $elem.removeClass('w-e-active');
      }
    }
  };

  /*
    italic-menu
*/
  // 构造函数
  function Italic(editor) {
    this.editor = editor;
    this.$elem = $('<div class="w-e-menu">\n            <i class="w-e-icon-italic"><i/>\n        </div>');
    this.type = 'click';

    // 当前是否 active 状态
    this._active = false;
  }

  // 原型
  Italic.prototype = {
    constructor: Italic,

    // 点击事件
    onClick: function onClick(e) {
      // 点击菜单将触发这里

      let editor = this.editor;
      let isSeleEmpty = editor.selection.isSelectionEmpty();

      if (isSeleEmpty) {
        // 选区是空的，插入并选中一个“空白”
        editor.selection.createEmptyRange();
      }

      // 执行 italic 命令
      editor.cmd.do('italic');

      if (isSeleEmpty) {
        // 需要将选取折叠起来
        editor.selection.collapseRange();
        editor.selection.restoreSelection();
      }
    },

    // 试图改变 active 状态
    tryChangeActive: function tryChangeActive(e) {
      let editor = this.editor;
      let $elem = this.$elem;
      if (editor.cmd.queryCommandState('italic')) {
        this._active = true;
        $elem.addClass('w-e-active');
      } else {
        this._active = false;
        $elem.removeClass('w-e-active');
      }
    }
  };

  /*
    redo-menu
*/
  // 构造函数
  function Redo(editor) {
    this.editor = editor;
    this.$elem = $('<div class="w-e-menu">\n            <i class="w-e-icon-redo"><i/>\n        </div>');
    this.type = 'click';

    // 当前是否 active 状态
    this._active = false;
  }

  // 原型
  Redo.prototype = {
    constructor: Redo,

    // 点击事件
    onClick: function onClick(e) {
      // 点击菜单将触发这里

      let editor = this.editor;

      // 执行 redo 命令
      editor.cmd.do('redo');
    }
  };

  /*
    strikeThrough-menu
*/
  // 构造函数
  function StrikeThrough(editor) {
    this.editor = editor;
    this.$elem = $('<div class="w-e-menu">\n            <i class="w-e-icon-strikethrough"><i/>\n        </div>');
    this.type = 'click';

    // 当前是否 active 状态
    this._active = false;
  }

  // 原型
  StrikeThrough.prototype = {
    constructor: StrikeThrough,

    // 点击事件
    onClick: function onClick(e) {
      // 点击菜单将触发这里

      let editor = this.editor;
      let isSeleEmpty = editor.selection.isSelectionEmpty();

      if (isSeleEmpty) {
        // 选区是空的，插入并选中一个“空白”
        editor.selection.createEmptyRange();
      }

      // 执行 strikeThrough 命令
      editor.cmd.do('strikeThrough');

      if (isSeleEmpty) {
        // 需要将选取折叠起来
        editor.selection.collapseRange();
        editor.selection.restoreSelection();
      }
    },

    // 试图改变 active 状态
    tryChangeActive: function tryChangeActive(e) {
      let editor = this.editor;
      let $elem = this.$elem;
      if (editor.cmd.queryCommandState('strikeThrough')) {
        this._active = true;
        $elem.addClass('w-e-active');
      } else {
        this._active = false;
        $elem.removeClass('w-e-active');
      }
    }
  };

  /*
    underline-menu
*/
  // 构造函数
  function Underline(editor) {
    this.editor = editor;
    this.$elem = $('<div class="w-e-menu">\n            <i class="w-e-icon-underline"><i/>\n        </div>');
    this.type = 'click';

    // 当前是否 active 状态
    this._active = false;
  }

  // 原型
  Underline.prototype = {
    constructor: Underline,

    // 点击事件
    onClick: function onClick(e) {
      // 点击菜单将触发这里

      let editor = this.editor;
      let isSeleEmpty = editor.selection.isSelectionEmpty();

      if (isSeleEmpty) {
        // 选区是空的，插入并选中一个“空白”
        editor.selection.createEmptyRange();
      }

      // 执行 underline 命令
      editor.cmd.do('underline');

      if (isSeleEmpty) {
        // 需要将选取折叠起来
        editor.selection.collapseRange();
        editor.selection.restoreSelection();
      }
    },

    // 试图改变 active 状态
    tryChangeActive: function tryChangeActive(e) {
      let editor = this.editor;
      let $elem = this.$elem;
      if (editor.cmd.queryCommandState('underline')) {
        this._active = true;
        $elem.addClass('w-e-active');
      } else {
        this._active = false;
        $elem.removeClass('w-e-active');
      }
    }
  };

  /*
    undo-menu
*/
  // 构造函数
  function Undo(editor) {
    this.editor = editor;
    this.$elem = $('<div class="w-e-menu">\n            <i class="w-e-icon-undo"><i/>\n        </div>');
    this.type = 'click';

    // 当前是否 active 状态
    this._active = false;
  }

  // 原型
  Undo.prototype = {
    constructor: Undo,

    // 点击事件
    onClick: function onClick(e) {
      // 点击菜单将触发这里

      let editor = this.editor;

      // 执行 undo 命令
      editor.cmd.do('undo');
    }
  };

  /*
    menu - list
*/
  // 构造函数
  function List(editor) {
    let _this = this;

    this.editor = editor;
    this.$elem = $('<div class="w-e-menu"><i class="w-e-icon-list2"><i/></div>');
    this.type = 'droplist';

    // 当前是否 active 状态
    this._active = false;

    // 初始化 droplist
    this.droplist = new DropList(this, {
      width: 120,
      $title: $('<p>设置列表</p>'),
      type: 'list', // droplist 以列表形式展示
      list: [{ $elem: $('<span><i class="w-e-icon-list-numbered"></i> 有序列表</span>'), value: 'insertOrderedList' }, { $elem: $('<span><i class="w-e-icon-list2"></i> 无序列表</span>'), value: 'insertUnorderedList' }],
      onClick: function onClick(value) {
        // 注意 this 是指向当前的 List 对象
        _this._command(value);
      }
    });
  }

  // 原型
  List.prototype = {
    constructor: List,

    // 执行命令
    _command: function _command(value) {
      let editor = this.editor;
      let $textElem = editor.$textElem;
      editor.selection.restoreSelection();
      if (editor.cmd.queryCommandState(value)) {
        return;
      }
      editor.cmd.do(value);

      // 验证列表是否被包裹在 <p> 之内
      let $selectionElem = editor.selection.getSelectionContainerElem();
      if ($selectionElem.getNodeName() === 'LI') {
        $selectionElem = $selectionElem.parent();
      }
      if (/^ol|ul$/i.test($selectionElem.getNodeName()) === false) {
        return;
      }
      if ($selectionElem.equal($textElem)) {
        // 证明是顶级标签，没有被 <p> 包裹
        return;
      }
      let $parent = $selectionElem.parent();
      if ($parent.equal($textElem)) {
        // $parent 是顶级标签，不能删除
        return;
      }

      $selectionElem.insertAfter($parent);
      $parent.remove();
    },

    // 试图改变 active 状态
    tryChangeActive: function tryChangeActive(e) {
      let editor = this.editor;
      let $elem = this.$elem;
      if (editor.cmd.queryCommandState('insertUnOrderedList') || editor.cmd.queryCommandState('insertOrderedList')) {
        this._active = true;
        $elem.addClass('w-e-active');
      } else {
        this._active = false;
        $elem.removeClass('w-e-active');
      }
    }
  };

  /*
    menu - justify
*/
  // 构造函数
  function Justify(editor) {
    let _this = this;

    this.editor = editor;
    this.$elem = $('<div class="w-e-menu"><i class="w-e-icon-paragraph-left"><i/></div>');
    this.type = 'droplist';

    // 当前是否 active 状态
    this._active = false;

    // 初始化 droplist
    this.droplist = new DropList(this, {
      width: 100,
      $title: $(`<p>${i18n.t('wangEditor.alignment')}</p>`),
      type: 'list', // droplist 以列表形式展示
      list: [{ $elem: $('<span><i class="w-e-icon-paragraph-left"></i> 靠左</span>'), value: 'justifyLeft' }, { $elem: $('<span><i class="w-e-icon-paragraph-center"></i> 居中</span>'), value: 'justifyCenter' }, { $elem: $('<span><i class="w-e-icon-paragraph-right"></i> 靠右</span>'), value: 'justifyRight' }],
      onClick: function onClick(value) {
        // 注意 this 是指向当前的 List 对象
        _this._command(value);
      }
    });
  }

  // 原型
  Justify.prototype = {
    constructor: Justify,

    // 执行命令
    _command: function _command(value) {
      let editor = this.editor;
      editor.cmd.do(value);
    }
  };

  /*
    menu - Forecolor
*/
  // 构造函数
  function ForeColor(editor) {
    let _this = this;

    this.editor = editor;
    this.$elem = $('<div class="w-e-menu"><i class="w-e-icon-pencil2"><i/></div>');
    this.type = 'droplist';

    // 获取配置的颜色
    let config = editor.config;
    let colors = config.colors || [];

    // 当前是否 active 状态
    this._active = false;

    // 初始化 droplist
    this.droplist = new DropList(this, {
      width: 120,
      $title: $(`<p>${i18n.t('wangEditor.textColor')}</p>`),
      type: 'inline-block', // droplist 内容以 block 形式展示
      list: colors.map((color) => {
            return { $elem: $('<i style="color:' + color + ';" class="w-e-icon-pencil2"></i>'), value: color };
        }),
      onClick: function onClick(value) {
        // 注意 this 是指向当前的 ForeColor 对象
        _this._command(value);
      }
    });
  }

  // 原型
  ForeColor.prototype = {
    constructor: ForeColor,

    // 执行命令
    _command: function _command(value) {
      let editor = this.editor;
      editor.cmd.do('foreColor', value);
    }
  };

  /*
    menu - BackColor
*/
  // 构造函数
  function BackColor(editor) {
    let _this = this;

    this.editor = editor;
    this.$elem = $('<div class="w-e-menu"><i class="w-e-icon-paint-brush"><i/></div>');
    this.type = 'droplist';

    // 获取配置的颜色
    let config = editor.config;
    let colors = config.colors || [];

    // 当前是否 active 状态
    this._active = false;

    // 初始化 droplist
    this.droplist = new DropList(this, {
      width: 120,
      $title: $(`<p>${i18n.t('wangEditor.backgroundColor')}</p>`),
      type: 'inline-block', // droplist 内容以 block 形式展示
      list: colors.map((color) => {
            return { $elem: $('<i style="color:' + color + ';" class="w-e-icon-paint-brush"></i>'), value: color };
        }),
      onClick: function onClick(value) {
        // 注意 this 是指向当前的 BackColor 对象
        _this._command(value);
      }
    });
  }

  // 原型
  BackColor.prototype = {
    constructor: BackColor,

    // 执行命令
    _command: function _command(value) {
      let editor = this.editor;
      editor.cmd.do('backColor', value);
    }
  };

  /*
    menu - quote
*/
  // 构造函数
  function Quote(editor) {
    this.editor = editor;
    this.$elem = $('<div class="w-e-menu">\n            <i class="w-e-icon-quotes-left"><i/>\n        </div>');
    this.type = 'click';

    // 当前是否 active 状态
    this._active = false;
  }

  // 原型
  Quote.prototype = {
    constructor: Quote,

    onClick: function onClick(e) {
      let editor = this.editor;
      let $selectionElem = editor.selection.getSelectionContainerElem();
      let nodeName = $selectionElem.getNodeName();

      if (!UA.isIE()) {
        if (nodeName === 'BLOCKQUOTE') {
          // 撤销 quote
          editor.cmd.do('formatBlock', '<P>');
        } else {
          // 转换为 quote
          editor.cmd.do('formatBlock', '<BLOCKQUOTE>');
        }
        return;
      }

      // IE 中不支持 formatBlock <BLOCKQUOTE> ，要用其他方式兼容
      let content = void 0;
            var $targetELem = void 0;
      if (nodeName === 'P') {
        // 将 P 转换为 quote
        content = $selectionElem.text();
        $targetELem = $(`<blockquote>${  content  }</blockquote>`);
        $targetELem.insertAfter($selectionElem);
        $selectionElem.remove();
        return;
      }
      if (nodeName === 'BLOCKQUOTE') {
        // 撤销 quote
        content = $selectionElem.text();
        $targetELem = $(`<p>${  content  }</p>`);
        $targetELem.insertAfter($selectionElem);
        $selectionElem.remove();
      }
    },

    tryChangeActive: function tryChangeActive(e) {
      let editor = this.editor;
      let $elem = this.$elem;
      let reg = /^BLOCKQUOTE$/i;
      let cmdValue = editor.cmd.queryCommandValue('formatBlock');
      if (reg.test(cmdValue)) {
        this._active = true;
        $elem.addClass('w-e-active');
      } else {
        this._active = false;
        $elem.removeClass('w-e-active');
      }
    }
  };

  /*
    menu - code
*/
  // 构造函数
  function Code(editor) {
    this.editor = editor;
    this.$elem = $('<div class="w-e-menu">\n            <i class="w-e-icon-terminal"><i/>\n        </div>');
    this.type = 'panel';

    // 当前是否 active 状态
    this._active = false;
  }

  // 原型
  Code.prototype = {
    constructor: Code,

    onClick: function onClick(e) {
      let editor = this.editor;
      let $startElem = editor.selection.getSelectionStartElem();
      let $endElem = editor.selection.getSelectionEndElem();
      let isSeleEmpty = editor.selection.isSelectionEmpty();
      let selectionText = editor.selection.getSelectionText();
      let $code = void 0;

      if (!$startElem.equal($endElem)) {
        // 跨元素选择，不做处理
        editor.selection.restoreSelection();
        return;
      }
      if (!isSeleEmpty) {
        // 选取不是空，用 <code> 包裹即可
        $code = $(`<code>${  selectionText  }</code>`);
        editor.cmd.do('insertElem', $code);
        editor.selection.createRangeByElem($code, false);
        editor.selection.restoreSelection();
        return;
      }

      // 选取是空，且没有夸元素选择，则插入 <pre><code></code></prev>
      if (this._active) {
        // 选中状态，将编辑内容
        this._createPanel($startElem.html());
      } else {
        // 未选中状态，将创建内容
        this._createPanel();
      }
    },

    _createPanel: function _createPanel(value) {
      let _this = this;

      // value - 要编辑的内容
      value = value || '';
      let type = !value ? 'new' : 'edit';
      let textId = getRandom('texxt');
      let btnId = getRandom('btn');

      let panel = new Panel(this, {
        width: 500,
        // 一个 Panel 包含多个 tab
        tabs: [{
          // 标题
          title: i18n.t('tips.insertCode'),
          // 模板
          tpl: `<div>\n                        <textarea id="${  textId  }" style="height:145px;;">${  value  }</textarea>\n                        <div class="w-e-button-container">\n                            <button id="${  btnId  }" class="right">\u63D2\u5165</button>\n                        </div>\n                    <div>`,
          // 事件绑定
          events: [
            // 插入代码
            {
              selector: `#${  btnId}`,
              type: 'click',
              fn: function fn() {
                let $text = $(`#${  textId}`);
                let text = $text.val() || $text.html();
                text = replaceHtmlSymbol(text);
                if (type === 'new') {
                  // 新插入
                  _this._insertCode(text);
                } else {
                  // 编辑更新
                  _this._updateCode(text);
                }

                // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
                return true;
              }
            }]
        } // first tab end
        ] // tabs end
      }); // new Panel end

      // 显示 panel
      panel.show();

      // 记录属性
      this.panel = panel;
    },

    // 插入代码
    _insertCode: function _insertCode(value) {
      let editor = this.editor;
      editor.cmd.do('insertHTML', `<pre><code>${  value  }</code></pre><p><br></p>`);
    },

    // 更新代码
    _updateCode: function _updateCode(value) {
      let editor = this.editor;
      let $selectionELem = editor.selection.getSelectionContainerElem();
      if (!$selectionELem) {
        return;
      }
      $selectionELem.html(value);
      editor.selection.restoreSelection();
    },

    // 试图改变 active 状态
    tryChangeActive: function tryChangeActive(e) {
      let editor = this.editor;
      let $elem = this.$elem;
      let $selectionELem = editor.selection.getSelectionContainerElem();
      if (!$selectionELem) {
        return;
      }
      let $parentElem = $selectionELem.parent();
      if ($selectionELem.getNodeName() === 'CODE' && $parentElem.getNodeName() === 'PRE') {
        this._active = true;
        $elem.addClass('w-e-active');
      } else {
        this._active = false;
        $elem.removeClass('w-e-active');
      }
    }
  };

  /*
    menu - emoticon
*/
  // 构造函数
  function Emoticon(editor) {
    this.editor = editor;
    this.$elem = $('<div class="w-e-menu">\n            <i class="w-e-icon-happy"><i/>\n        </div>');
    this.type = 'panel';

    // 当前是否 active 状态
    this._active = false;
  }

  // 原型
  Emoticon.prototype = {
    constructor: Emoticon,

    onClick: function onClick() {
      this._createPanel();
    },

    _createPanel: function _createPanel() {
      let _this = this;

      let editor = this.editor;
      let config = editor.config;
      // 获取表情配置
      let emotions = config.emotions || [];

      // 创建表情 dropPanel 的配置
      let tabConfig = [];
      emotions.forEach((emotData) => {
            var emotType = emotData.type;
            var content = emotData.content || [];

            // 这一组表情最终拼接出来的 html
            var faceHtml = '';

            // emoji 表情
            if (emotType === 'emoji') {
                content.forEach(function (item) {
                    if (item) {
                        faceHtml += '<span class="w-e-item">' + item + '</span>';
                    }
                });
            }
            // 图片表情
            if (emotType === 'image') {
                content.forEach(function (item) {
                    var src = item.src;
                    var alt = item.alt;
                    if (src) {
                        // 加一个 data-w-e 属性，点击图片的时候不再提示编辑图片
                        faceHtml += '<span class="w-e-item"><img src="' + src + '" alt="' + alt + '" data-w-e="1"/></span>';
                    }
                });
            }

            tabConfig.push({
                title: emotData.title,
                tpl: '<div class="w-e-emoticon-container">' + faceHtml + '</div>',
                events: [{
                    selector: 'span.w-e-item',
                    type: 'click',
                    fn: function fn(e) {
                        var target = e.target;
                        var $target = $(target);
                        var nodeName = $target.getNodeName();

                        var insertHtml = void 0;
                        if (nodeName === 'IMG') {
                            // 插入图片
                            insertHtml = $target.parent().html();
                        } else {
                            // 插入 emoji
                            insertHtml = '<span>' + $target.html() + '</span>';
                        }

                        _this._insert(insertHtml);
                        // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
                        return true;
                    }
                }]
            });
        });

      let panel = new Panel(this, {
        width: 300,
        height: 200,
        // 一个 Panel 包含多个 tab
        tabs: tabConfig
      });

      // 显示 panel
      panel.show();

      // 记录属性
      this.panel = panel;
    },

    // 插入表情
    _insert: function _insert(emotHtml) {
      let editor = this.editor;
      editor.cmd.do('insertHTML', emotHtml);
    }
  };

  /*
    menu - table
*/
  // 构造函数
  function Table(editor) {
    this.editor = editor;
    this.$elem = $('<div class="w-e-menu"><i class="w-e-icon-table2"><i/></div>');
    this.type = 'panel';

    // 当前是否 active 状态
    this._active = false;
  }

  // 原型
  Table.prototype = {
    constructor: Table,

    onClick: function onClick() {
      if (this._active) {
        // 编辑现有表格
        this._createEditPanel();
      } else {
        // 插入新表格
        this._createInsertPanel();
      }
    },

    // 创建插入新表格的 panel
    _createInsertPanel: function _createInsertPanel() {
      let _this = this;

      // 用到的 id
      let btnInsertId = getRandom('btn');
      let textRowNum = getRandom('row');
      let textColNum = getRandom('col');

      let panel = new Panel(this, {
        width: 250,
        // panel 包含多个 tab
        tabs: [{
          // 标题
          title: i18n.t('tips.insertTable'),
          // 模板
          tpl: `<div>\n                        <p style="text-align:left; padding:5px 0;">\n                            \u521B\u5EFA\n                            <input id="${  textRowNum  }" type="text" value="5" style="width:40px;text-align:center;"/>\n                            \u884C\n                            <input id="${  textColNum  }" type="text" value="5" style="width:40px;text-align:center;"/>\n                            \u5217\u7684\u8868\u683C\n                        </p>\n                        <div class="w-e-button-container">\n                            <button id="${  btnInsertId  }" class="right">\u63D2\u5165</button>\n                        </div>\n                    </div>`,
          // 事件绑定
          events: [{
            // 点击按钮，插入表格
            selector: `#${  btnInsertId}`,
            type: 'click',
            fn: function fn() {
              let rowNum = parseInt($(`#${  textRowNum}`).val());
              let colNum = parseInt($(`#${  textColNum}`).val());

              if (rowNum && colNum && rowNum > 0 && colNum > 0) {
                // form 数据有效
                _this._insert(rowNum, colNum);
              }

              // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
              return true;
            }
          }]
        } // first tab end
        ] // tabs end
      }); // panel end

      // 展示 panel
      panel.show();

      // 记录属性
      this.panel = panel;
    },

    // 插入表格
    _insert: function _insert(rowNum, colNum) {
      // 拼接 table 模板
      let r = void 0;
            var c = void 0;
      let html = '<table border="0" width="100%" cellpadding="0" cellspacing="0">';
      for (r = 0; r < rowNum; r++) {
        html += '<tr>';
        if (r === 0) {
          for (c = 0; c < colNum; c++) {
            html += '<th>&nbsp;</th>';
          }
        } else {
          for (c = 0; c < colNum; c++) {
            html += '<td>&nbsp;</td>';
          }
        }
        html += '</tr>';
      }
      html += '</table><p><br></p>';

      // 执行命令
      let editor = this.editor;
      editor.cmd.do('insertHTML', html);

      // 防止 firefox 下出现 resize 的控制点
      editor.cmd.do('enableObjectResizing', false);
      editor.cmd.do('enableInlineTableEditing', false);
    },

    // 创建编辑表格的 panel
    _createEditPanel: function _createEditPanel() {
      let _this2 = this;

      // 可用的 id
      let addRowBtnId = getRandom('add-row');
      let addColBtnId = getRandom('add-col');
      let delRowBtnId = getRandom('del-row');
      let delColBtnId = getRandom('del-col');
      let delTableBtnId = getRandom('del-table');

      // 创建 panel 对象
      let panel = new Panel(this, {
        width: 320,
        // panel 包含多个 tab
        tabs: [{
          // 标题
          title: i18n.t('tips.editTable'),
          // 模板
          tpl: `<div>\n                        <div class="w-e-button-container" style="border-bottom:1px solid #f1f1f1;padding-bottom:5px;margin-bottom:5px;">\n                            <button id="${  addRowBtnId  }" class="left">\u589E\u52A0\u884C</button>\n                            <button id="${  delRowBtnId  }" class="red left">\u5220\u9664\u884C</button>\n                            <button id="${  addColBtnId  }" class="left">\u589E\u52A0\u5217</button>\n                            <button id="${  delColBtnId  }" class="red left">\u5220\u9664\u5217</button>\n                        </div>\n                        <div class="w-e-button-container">\n                            <button id="${  delTableBtnId  }" class="gray left">\u5220\u9664\u8868\u683C</button>\n                        </dv>\n                    </div>`,
          // 事件绑定
          events: [{
            // 增加行
            selector: `#${  addRowBtnId}`,
            type: 'click',
            fn: function fn() {
              _this2._addRow();
              // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
              return true;
            }
          }, {
            // 增加列
            selector: `#${  addColBtnId}`,
            type: 'click',
            fn: function fn() {
              _this2._addCol();
              // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
              return true;
            }
          }, {
            // 删除行
            selector: `#${  delRowBtnId}`,
            type: 'click',
            fn: function fn() {
              _this2._delRow();
              // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
              return true;
            }
          }, {
            // 删除列
            selector: `#${  delColBtnId}`,
            type: 'click',
            fn: function fn() {
              _this2._delCol();
              // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
              return true;
            }
          }, {
            // 删除表格
            selector: `#${  delTableBtnId}`,
            type: 'click',
            fn: function fn() {
              _this2._delTable();
              // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
              return true;
            }
          }]
        }]
      });
        // 显示 panel
      panel.show();
    },

    // 获取选中的单元格的位置信息
    _getLocationData: function _getLocationData() {
      let result = {};
      let editor = this.editor;
      let $selectionELem = editor.selection.getSelectionContainerElem();
      if (!$selectionELem) {
        return;
      }
      let nodeName = $selectionELem.getNodeName();
      if (nodeName !== 'TD' && nodeName !== 'TH') {
        return;
      }

      // 获取 td index
      let $tr = $selectionELem.parent();
      let $tds = $tr.children();
      let tdLength = $tds.length;
      $tds.forEach((td, index) => {
            if (td === $selectionELem[0]) {
                // 记录并跳出循环
                result.td = {
                    index: index,
                    elem: td,
                    length: tdLength
                };
                return false;
            }
        });

      // 获取 tr index
      let $tbody = $tr.parent();
      let $trs = $tbody.children();
      let trLength = $trs.length;
      $trs.forEach((tr, index) => {
            if (tr === $tr[0]) {
                // 记录并跳出循环
                result.tr = {
                    index: index,
                    elem: tr,
                    length: trLength
                };
                return false;
            }
        });

      // 返回结果
      return result;
    },

    // 增加行
    _addRow: function _addRow() {
      // 获取当前单元格的位置信息
      let locationData = this._getLocationData();
      if (!locationData) {
        return;
      }
      let trData = locationData.tr;
      let $currentTr = $(trData.elem);
      let tdData = locationData.td;
      let tdLength = tdData.length;

      // 拼接即将插入的字符串
      let newTr = document.createElement('tr');
      let tpl = '';
            var i = void 0;
      for (i = 0; i < tdLength; i++) {
        tpl += '<td>&nbsp;</td>';
      }
      newTr.innerHTML = tpl;
      // 插入
      $(newTr).insertAfter($currentTr);
    },

    // 增加列
    _addCol: function _addCol() {
      // 获取当前单元格的位置信息
      let locationData = this._getLocationData();
      if (!locationData) {
        return;
      }
      let trData = locationData.tr;
      let tdData = locationData.td;
      let tdIndex = tdData.index;
      let $currentTr = $(trData.elem);
      let $trParent = $currentTr.parent();
      let $trs = $trParent.children();

      // 遍历所有行
      $trs.forEach((tr) => {
            var $tr = $(tr);
            var $tds = $tr.children();
            var $currentTd = $tds.get(tdIndex);
            var name = $currentTd.getNodeName().toLowerCase();

            // new 一个 td，并插入
            var newTd = document.createElement(name);
            $(newTd).insertAfter($currentTd);
        });
    },

    // 删除行
    _delRow: function _delRow() {
      // 获取当前单元格的位置信息
      let locationData = this._getLocationData();
      if (!locationData) {
        return;
      }
      let trData = locationData.tr;
      let $currentTr = $(trData.elem);
      $currentTr.remove();
    },

    // 删除列
    _delCol: function _delCol() {
      // 获取当前单元格的位置信息
      let locationData = this._getLocationData();
      if (!locationData) {
        return;
      }
      let trData = locationData.tr;
      let tdData = locationData.td;
      let tdIndex = tdData.index;
      let $currentTr = $(trData.elem);
      let $trParent = $currentTr.parent();
      let $trs = $trParent.children();

      // 遍历所有行
      $trs.forEach((tr) => {
            var $tr = $(tr);
            var $tds = $tr.children();
            var $currentTd = $tds.get(tdIndex);
            // 删除
            $currentTd.remove();
        });
    },

    // 删除表格
    _delTable: function _delTable() {
      let editor = this.editor;
      let $selectionELem = editor.selection.getSelectionContainerElem();
      if (!$selectionELem) {
        return;
      }
      let $table = $selectionELem.parentUntil('table');
      if (!$table) {
        return;
      }
      $table.remove();
    },

    // 试图改变 active 状态
    tryChangeActive: function tryChangeActive(e) {
      let editor = this.editor;
      let $elem = this.$elem;
      let $selectionELem = editor.selection.getSelectionContainerElem();
      if (!$selectionELem) {
        return;
      }
      let nodeName = $selectionELem.getNodeName();
      if (nodeName === 'TD' || nodeName === 'TH') {
        this._active = true;
        $elem.addClass('w-e-active');
      } else {
        this._active = false;
        $elem.removeClass('w-e-active');
      }
    }
  };

  /*
    menu - video
*/
  // 构造函数
  function Video(editor) {
    this.editor = editor;
    this.$elem = $('<div class="w-e-menu"><i class="w-e-icon-play"><i/></div>');
    this.type = 'panel';

    // 当前是否 active 状态
    this._active = false;
  }

  // 原型
  Video.prototype = {
    constructor: Video,

    onClick: function onClick() {
      this._createPanel();
    },

    _createPanel: function _createPanel() {
      let _this = this;

      // 创建 id
      let textValId = getRandom('text-val');
      let btnId = getRandom('btn');

      // 创建 panel
      let panel = new Panel(this, {
        width: 350,
        // 一个 panel 多个 tab
        tabs: [{
          // 标题
          title: i18n.t('tips.insertVideo'),
          // 模板
          tpl: `<div>\n                        <input id="${  textValId  }" type="text" class="block" placeholder="${i18n.t('wangEditor.enterVideoAddress')}"/>\n                        <div class="w-e-button-container">\n                            <button id="${  btnId  }" class="right">\u63D2\u5165</button>\n                        </div>\n                    </div>`,
          // 事件绑定
          events: [{
            selector: `#${  btnId}`,
            type: 'click',
            fn: function fn() {
              let $text = $(`#${  textValId}`);
              let val = $text.val().trim();

              /**
                       * 修改插入视频方式
                       *
                       // 测试用视频地址
                       // <iframe height=498 width=510 src='http://player.youku.com/embed/XMjcwMzc3MzM3Mg==' frameborder=0 'allowfullscreen'></iframe>

                       if (val) {
                            // 插入视频
                            _this._insert(val);
                        }

                       // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
                       return true;
                       */
              let html = `<div style="width: 480px;border: 1px solid #D6D6D6;margin: 10px auto;overflow: hidden;"><video src="${val}" autoplay="true" controls="controls" width="100%" style="float: left;"></video></div>`;
              if (val) {
                // 插入视频
                _this._insert(html);
              }
              return true;
            }
          }]
        } // first tab end
        ] // tabs end
      }); // panel end

      // 显示 panel
      panel.show();

      // 记录属性
      this.panel = panel;
    },

    // 插入视频
    _insert: function _insert(val) {
      let editor = this.editor;
      editor.cmd.do('insertHTML', `${val  }<p><br></p>`);
    }
  };

  /*
    menu - img
*/
  // 构造函数
  function Image(editor) {
    this.editor = editor;
    let imgMenuId = getRandom('w-e-img');
    this.$elem = $(`<div class="w-e-menu" id="${  imgMenuId  }"><i class="w-e-icon-image"><i/></div>`);
    editor.imgMenuId = imgMenuId;
    this.type = 'panel';

    // 当前是否 active 状态
    this._active = false;
  }

  // 原型
  Image.prototype = {
    constructor: Image,

    onClick: function onClick() {
      let editor = this.editor;
      let config = editor.config;
      if (config.qiniu) {
        return;
      }
      if (this._active) {
        this._createEditPanel();
      } else {
        this._createInsertPanel();
      }
    },

    _createEditPanel: function _createEditPanel() {
      let editor = this.editor;

      // id
      let width30 = getRandom('width-30');
      let width50 = getRandom('width-50');
      let width100 = getRandom('width-100');
      let delBtn = getRandom('del-btn');

      // tab 配置
      let tabsConfig = [{
        title: i18n.t('tips.editPicture'),
        tpl: `<div>\n                    <div class="w-e-button-container" style="border-bottom:1px solid #f1f1f1;padding-bottom:5px;margin-bottom:5px;">\n                        <span style="float:left;font-size:14px;margin:4px 5px 0 5px;color:#333;">\u6700\u5927\u5BBD\u5EA6\uFF1A</span>\n                        <button id="${  width30  }" class="left">30%</button>\n                        <button id="${  width50  }" class="left">50%</button>\n                        <button id="${  width100  }" class="left">100%</button>\n                    </div>\n                    <div class="w-e-button-container">\n                        <button id="${  delBtn  }" class="gray left">\u5220\u9664\u56FE\u7247</button>\n                    </dv>\n                </div>`,
        events: [{
          selector: `#${  width30}`,
          type: 'click',
          fn: function fn() {
            let $img = editor._selectedImg;
            if ($img) {
              $img.css('max-width', '30%');
            }
            // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
            return true;
          }
        }, {
          selector: `#${  width50}`,
          type: 'click',
          fn: function fn() {
            let $img = editor._selectedImg;
            if ($img) {
              $img.css('max-width', '50%');
            }
            // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
            return true;
          }
        }, {
          selector: `#${  width100}`,
          type: 'click',
          fn: function fn() {
            let $img = editor._selectedImg;
            if ($img) {
              $img.css('max-width', '100%');
            }
            // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
            return true;
          }
        }, {
          selector: `#${  delBtn}`,
          type: 'click',
          fn: function fn() {
            let $img = editor._selectedImg;
            if ($img) {
              $img.remove();
            }
            // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
            return true;
          }
        }]
      }];

      // 创建 panel 并显示
      let panel = new Panel(this, {
        width: 300,
        tabs: tabsConfig
      });
      panel.show();

      // 记录属性
      this.panel = panel;
    },

    _createInsertPanel: function _createInsertPanel() {
      let editor = this.editor;
      let uploadImg = editor.uploadImg;
      let config = editor.config;

      // id
      let upTriggerId = getRandom('up-trigger');
      let upFileId = getRandom('up-file');
      let linkUrlId = getRandom('link-url');
      let linkBtnId = getRandom('link-btn');

      // tabs 的配置
      let tabsConfig = [{
        title: i18n.t('tips.uploadImage'),
        tpl: `<div class="w-e-up-img-container">\n                    <div id="${  upTriggerId  }" class="w-e-up-btn">\n                        <i class="w-e-icon-upload2"></i>\n                    </div>\n                    <div style="display:none;">\n                        <input id="${  upFileId  }" type="file" multiple="multiple" accept="image/jpg,image/jpeg,image/png,image/gif,image/bmp"/>\n                    </div>\n                </div>`,
        events: [{
          // 触发选择图片
          selector: `#${  upTriggerId}`,
          type: 'click',
          fn: function fn() {
            let $file = $(`#${  upFileId}`);
            let fileElem = $file[0];
            if (fileElem) {
              fileElem.click();
            } else {
              // 返回 true 可关闭 panel
              return true;
            }
          }
        }, {
          // 选择图片完毕
          selector: `#${  upFileId}`,
          type: 'change',
          fn: function fn() {
            let $file = $(`#${  upFileId}`);
            let fileElem = $file[0];
            if (!fileElem) {
              // 返回 true 可关闭 panel
              return true;
            }

            // 获取选中的 file 对象列表
            let fileList = fileElem.files;
            if (fileList.length) {
              uploadImg.uploadImg(fileList);
            }

            // 返回 true 可关闭 panel
            return true;
          }
        }]
      }, // first tab end
      {
        title: i18n.t('tips.webImage'),
        tpl: `<div>\n                    <input id="${  linkUrlId  }" type="text" class="block" placeholder="\u56FE\u7247\u94FE\u63A5"/></td>\n                    <div class="w-e-button-container">\n                        <button id="${  linkBtnId  }" class="right">\u63D2\u5165</button>\n                    </div>\n                </div>`,
        events: [{
          selector: `#${  linkBtnId}`,
          type: 'click',
          fn: function fn() {
            let $linkUrl = $(`#${  linkUrlId}`);
            let url = $linkUrl.val().trim();

            if (url) {
              uploadImg.insertLinkImg(url);
            }

            // 返回 true 表示函数执行结束之后关闭 panel
            return true;
          }
        }]
      } // second tab end
      ]; // tabs end

      // 判断 tabs 的显示
      let tabsConfigResult = [];
      if ((config.uploadImgShowBase64 || config.uploadImgServer || config.customUploadImg) && window.FileReader) {
        // 显示“上传图片”
        tabsConfigResult.push(tabsConfig[0]);
      }
      if (config.showLinkImg) {
        // 显示“网络图片”
        tabsConfigResult.push(tabsConfig[1]);
      }

      // 创建 panel 并显示
      let panel = new Panel(this, {
        width: 300,
        tabs: tabsConfigResult
      });
      panel.show();

      // 记录属性
      this.panel = panel;
    },

    // 试图改变 active 状态
    tryChangeActive: function tryChangeActive(e) {
      let editor = this.editor;
      let $elem = this.$elem;
      if (editor._selectedImg) {
        this._active = true;
        $elem.addClass('w-e-active');
      } else {
        this._active = false;
        $elem.removeClass('w-e-active');
      }
    }
  };

  /*
    所有菜单的汇总
*/

  // 存储菜单的构造函数
  let MenuConstructors = {};

  MenuConstructors.bold = Bold;

  MenuConstructors.head = Head;

  MenuConstructors.link = Link;

  MenuConstructors.italic = Italic;

  MenuConstructors.redo = Redo;

  MenuConstructors.strikeThrough = StrikeThrough;

  MenuConstructors.underline = Underline;

  MenuConstructors.undo = Undo;

  MenuConstructors.list = List;

  MenuConstructors.justify = Justify;

  MenuConstructors.foreColor = ForeColor;

  MenuConstructors.backColor = BackColor;

  MenuConstructors.quote = Quote;

  MenuConstructors.code = Code;

  MenuConstructors.emoticon = Emoticon;

  MenuConstructors.table = Table;

  MenuConstructors.video = Video;

  MenuConstructors.image = Image;

  /*
    菜单集合
*/
  // 构造函数
  function Menus(editor) {
    this.editor = editor;
    this.menus = {};
  }

  // 修改原型
  Menus.prototype = {
    constructor: Menus,

    // 初始化菜单
    init: function init() {
      let _this = this;

      let editor = this.editor;
      let config = editor.config || {};
      let configMenus = config.menus || []; // 获取配置中的菜单

      // 根据配置信息，创建菜单
      configMenus.forEach((menuKey) => {
            var MenuConstructor = MenuConstructors[menuKey];
            if (MenuConstructor && typeof MenuConstructor === 'function') {
                // 创建单个菜单
                _this.menus[menuKey] = new MenuConstructor(editor);
            }
        });

      // 添加到菜单栏
      this._addToToolbar();

      // 绑定事件
      this._bindEvent();
    },

    // 添加到菜单栏
    _addToToolbar: function _addToToolbar() {
      let editor = this.editor;
      let $toolbarElem = editor.$toolbarElem;
      let menus = this.menus;
      let config = editor.config;
      // config.zIndex 是配置的编辑区域的 z-index，菜单的 z-index 得在其基础上 +1
      let zIndex = config.zIndex + 1;
      objForEach(menus, (key, menu) => {
            var $elem = menu.$elem;
            if ($elem) {
                // 设置 z-index
                $elem.css('z-index', zIndex);
                $toolbarElem.append($elem);
            }
        });
    },

    // 绑定菜单 click mouseenter 事件
    _bindEvent: function _bindEvent() {
      let menus = this.menus;
      let editor = this.editor;
      objForEach(menus, (key, menu) => {
            var type = menu.type;
            if (!type) {
                return;
            }
            var $elem = menu.$elem;
            var droplist = menu.droplist;
            var panel = menu.panel;

            // 点击类型，例如 bold
            if (type === 'click' && menu.onClick) {
                $elem.on('click', function (e) {
                    if (editor.selection.getRange() == null) {
                        return;
                    }
                    menu.onClick(e);
                });
            }

            // 下拉框，例如 head
            if (type === 'droplist' && droplist) {
                $elem.on('mouseenter', function (e) {
                    if (editor.selection.getRange() == null) {
                        return;
                    }
                    // 显示
                    droplist.showTimeoutId = setTimeout(function () {
                        droplist.show();
                    }, 200);
                }).on('mouseleave', function (e) {
                    // 隐藏
                    droplist.hideTimeoutId = setTimeout(function () {
                        droplist.hide();
                    }, 0);
                });
            }

            // 弹框类型，例如 link
            if (type === 'panel' && menu.onClick) {
                $elem.on('click', function (e) {
                    e.stopPropagation();
                    if (editor.selection.getRange() == null) {
                        return;
                    }
                    // 在自定义事件中显示 panel
                    menu.onClick(e);
                });
            }
        });
    },

    // 尝试修改菜单状态
    changeActive: function changeActive() {
      let menus = this.menus;
      objForEach(menus, (key, menu) => {
            if (menu.tryChangeActive) {
                setTimeout(function () {
                    menu.tryChangeActive();
                }, 100);
            }
        });
    }
  };

  /*
    粘贴信息的处理
*/

  // 获取粘贴的纯文本
  function getPasteText(e) {
    let clipboardData = e.clipboardData || e.originalEvent && e.originalEvent.clipboardData;
    let pasteText = void 0;
    if (clipboardData == null) {
      pasteText = window.clipboardData && window.clipboardData.getData('text');
    } else {
      pasteText = clipboardData.getData('text/plain');
    }

    return replaceHtmlSymbol(pasteText);
  }

  // 获取粘贴的html
  function getPasteHtml(e, filterStyle) {
    let clipboardData = e.clipboardData || e.originalEvent && e.originalEvent.clipboardData;
    let pasteText = void 0;
        var pasteHtml = void 0;
    if (clipboardData == null) {
      pasteText = window.clipboardData && window.clipboardData.getData('text');
    } else {
      pasteText = clipboardData.getData('text/plain');
      pasteHtml = clipboardData.getData('text/html');
    }
    if (!pasteHtml && pasteText) {
      pasteHtml = `<p>${  replaceHtmlSymbol(pasteText)  }</p>`;
    }
    if (!pasteHtml) {
      return;
    }

    // 过滤word中状态过来的无用字符
    let docSplitHtml = pasteHtml.split('</html>');
    if (docSplitHtml.length === 2) {
      pasteHtml = docSplitHtml[0];
    }

    // 过滤无用标签
    pasteHtml = pasteHtml.replace(/<(meta|script|link).+?>/igm, '');
    // 去掉注释
    pasteHtml = pasteHtml.replace(/<!--.*?-->/mg, '');

    if (filterStyle) {
      // 过滤样式
      pasteHtml = pasteHtml.replace(/\s?(class|style)=('|").+?('|")/igm, '');
    } else {
      // 保留样式
      pasteHtml = pasteHtml.replace(/\s?class=('|").+?('|")/igm, '');
    }

    return pasteHtml;
  }

  // 获取粘贴的图片文件
  function getPasteImgs(e) {
    let result = [];
    let txt = getPasteText(e);
    if (txt) {
      // 有文字，就忽略图片
      return result;
    }

    let clipboardData = e.clipboardData || e.originalEvent && e.originalEvent.clipboardData || {};
    let items = clipboardData.items;
    if (!items) {
      return result;
    }

    objForEach(items, (key, value) => {
        var type = value.type;
        if (/image/i.test(type)) {
            result.push(value.getAsFile());
        }
    });

    return result;
  }

  /*
    编辑区域
*/

  // 获取一个 elem.childNodes 的 JSON 数据
  function getChildrenJSON($elem) {
    let result = [];
    let $children = $elem.childNodes() || []; // 注意 childNodes() 可以获取文本节点
    $children.forEach((curElem) => {
        var elemResult = void 0;
        var nodeType = curElem.nodeType;

        // 文本节点
        if (nodeType === 3) {
            elemResult = curElem.textContent;
        }

        // 普通 DOM 节点
        if (nodeType === 1) {
            elemResult = {};

            // tag
            elemResult.tag = curElem.nodeName.toLowerCase();
            // attr
            var attrData = [];
            var attrList = curElem.attributes || {};
            var attrListLength = attrList.length || 0;
            for (var i = 0; i < attrListLength; i++) {
                var attr = attrList[i];
                attrData.push({
                    name: attr.name,
                    value: attr.value
                });
            }
            elemResult.attrs = attrData;
            // children（递归）
            elemResult.children = getChildrenJSON($(curElem));
        }

        result.push(elemResult);
    });
    return result;
  }

  // 构造函数
  function Text(editor) {
    this.editor = editor;
  }

  // 修改原型
  Text.prototype = {
    constructor: Text,

    // 初始化
    init: function init() {
      // 绑定事件
      this._bindEvent();
    },

    // 清空内容
    clear: function clear() {
      this.html('<p><br></p>');
    },

    // 获取 设置 html
    html: function html(val) {
        var editor = this.editor;
        var $textElem = editor.$textElem;
        if (val == null) {
            return $textElem.html();
        } 
            $textElem.html(val);

            // 初始化选取，将光标定位到内容尾部
            editor.initSelection();
        
    },

    // 获取 JSON
    getJSON: function getJSON() {
      let editor = this.editor;
      let $textElem = editor.$textElem;
      return getChildrenJSON($textElem);
    },

    // 获取 设置 text
    text: function text(val) {
        var editor = this.editor;
        var $textElem = editor.$textElem;
        if (val == null) {
            return $textElem.text();
        } 
            $textElem.text('<p>' + val + '</p>');

            // 初始化选取，将光标定位到内容尾部
            editor.initSelection();
        
    },

    // 追加内容
    append: function append(html) {
      let editor = this.editor;
      let $textElem = editor.$textElem;
      $textElem.append($(html));

      // 初始化选取，将光标定位到内容尾部
      editor.initSelection();
    },

    // 绑定事件
    _bindEvent: function _bindEvent() {
      // 实时保存选取
      this._saveRangeRealTime();

      // 按回车建时的特殊处理
      this._enterKeyHandle();

      // 清空时保留 <p><br></p>
      this._clearHandle();

      // 粘贴事件（粘贴文字，粘贴图片）
      this._pasteHandle();

      // tab 特殊处理
      this._tabHandle();

      // img 点击
      this._imgHandle();

      // 拖拽事件
      this._dragHandle();
    },

    // 实时保存选取
    _saveRangeRealTime: function _saveRangeRealTime() {
      let editor = this.editor;
      let $textElem = editor.$textElem;

      // 保存当前的选区
      function saveRange(e) {
        // 随时保存选区
        editor.selection.saveRange();
        // 更新按钮 ative 状态
        editor.menus.changeActive();
      }
      // 按键后保存
      $textElem.on('keyup', saveRange);
      $textElem.on('mousedown', (e) => {
            // mousedown 状态下，鼠标滑动到编辑区域外面，也需要保存选区
            $textElem.on('mouseleave', saveRange);
        });
      $textElem.on('mouseup', (e) => {
            saveRange();
            // 在编辑器区域之内完成点击，取消鼠标滑动到编辑区外面的事件
            $textElem.off('mouseleave', saveRange);
        });
    },

    // 按回车键时的特殊处理
    _enterKeyHandle: function _enterKeyHandle() {
      let editor = this.editor;
      let $textElem = editor.$textElem;

      function insertEmptyP($selectionElem) {
        let $p = $('<p><br></p>');
        $p.insertBefore($selectionElem);
        editor.selection.createRangeByElem($p, true);
        editor.selection.restoreSelection();
        $selectionElem.remove();
      }

      // 将回车之后生成的非 <p> 的顶级标签，改为 <p>
      function pHandle(e) {
        let $selectionElem = editor.selection.getSelectionContainerElem();
        let $parentElem = $selectionElem.parent();

        if ($parentElem.html() === '<code><br></code>') {
          // 回车之前光标所在一个 <p><code>.....</code></p> ，忽然回车生成一个空的 <p><code><br></code></p>
          // 而且继续回车跳不出去，因此只能特殊处理
          insertEmptyP($selectionElem);
          return;
        }

        if (!$parentElem.equal($textElem)) {
          // 不是顶级标签
          return;
        }

        let nodeName = $selectionElem.getNodeName();
        if (nodeName === 'P') {
          // 当前的标签是 P ，不用做处理
          return;
        }

        if ($selectionElem.text()) {
          // 有内容，不做处理
          return;
        }

        // 插入 <p> ，并将选取定位到 <p>，删除当前标签
        insertEmptyP($selectionElem);
      }

      $textElem.on('keyup', (e) => {
            if (e.keyCode !== 13) {
                // 不是回车键
                return;
            }
            // 将回车之后生成的非 <p> 的顶级标签，改为 <p>
            pHandle(e);
        });

      // <pre><code></code></pre> 回车时 特殊处理
      function codeHandle(e) {
        let $selectionElem = editor.selection.getSelectionContainerElem();
        if (!$selectionElem) {
          return;
        }
        let $parentElem = $selectionElem.parent();
        let selectionNodeName = $selectionElem.getNodeName();
        let parentNodeName = $parentElem.getNodeName();

        if (selectionNodeName !== 'CODE' || parentNodeName !== 'PRE') {
          // 不符合要求 忽略
          return;
        }

        if (!editor.cmd.queryCommandSupported('insertHTML')) {
          // 必须原生支持 insertHTML 命令
          return;
        }

        // 处理：光标定位到代码末尾，联系点击两次回车，即跳出代码块
        if (editor._willBreakCode === true) {
          // 此时可以跳出代码块
          // 插入 <p> ，并将选取定位到 <p>
          let $p = $('<p><br></p>');
          $p.insertAfter($parentElem);
          editor.selection.createRangeByElem($p, true);
          editor.selection.restoreSelection();

          // 修改状态
          editor._willBreakCode = false;

          e.preventDefault();
          return;
        }

        let _startOffset = editor.selection.getRange().startOffset;

        // 处理：回车时，不能插入 <br> 而是插入 \n ，因为是在 pre 标签里面
        editor.cmd.do('insertHTML', '\n');
        editor.selection.saveRange();
        if (editor.selection.getRange().startOffset === _startOffset) {
          // 没起作用，再来一遍
          editor.cmd.do('insertHTML', '\n');
        }

        let codeLength = $selectionElem.html().length;
        if (editor.selection.getRange().startOffset + 1 === codeLength) {
          // 说明光标在代码最后的位置，执行了回车操作
          // 记录下来，以便下次回车时候跳出 code
          editor._willBreakCode = true;
        }

        // 阻止默认行为
        e.preventDefault();
      }

      $textElem.on('keydown', (e) => {
            if (e.keyCode !== 13) {
                // 不是回车键
                // 取消即将跳转代码块的记录
                editor._willBreakCode = false;
                return;
            }
            // <pre><code></code></pre> 回车时 特殊处理
            codeHandle(e);
        });
    },

    // 清空时保留 <p><br></p>
    _clearHandle: function _clearHandle() {
      let editor = this.editor;
      let $textElem = editor.$textElem;

      $textElem.on('keydown', function (e) {
            if (e.keyCode !== 8) {
                return;
            }
            var txtHtml = $textElem.html().toLowerCase().trim();
            if (txtHtml === '<p><br></p>') {
                // 最后剩下一个空行，就不再删除了
                e.preventDefault();
                
            }
        });

      $textElem.on('keyup', (e) => {
            if (e.keyCode !== 8) {
                return;
            }
            var $p = void 0;
            var txtHtml = $textElem.html().toLowerCase().trim();

            // firefox 时用 txtHtml === '<br>' 判断，其他用 !txtHtml 判断
            if (!txtHtml || txtHtml === '<br>') {
                // 内容空了
                $p = $('<p><br/></p>');
                $textElem.html(''); // 一定要先清空，否则在 firefox 下有问题
                $textElem.append($p);
                editor.selection.createRangeByElem($p, false, true);
                editor.selection.restoreSelection();
            }
        });
    },

    // 粘贴事件（粘贴文字 粘贴图片）
    _pasteHandle: function _pasteHandle() {
      let editor = this.editor;
      let config = editor.config;
      let pasteFilterStyle = config.pasteFilterStyle;
      let pasteTextHandle = config.pasteTextHandle;
      let $textElem = editor.$textElem;

      // 粘贴图片、文本的事件，每次只能执行一个
      // 判断该次粘贴事件是否可以执行
      let pasteTime = 0;
      function canDo() {
        let now = Date.now();
        let flag = false;
        if (now - pasteTime >= 500) {
          // 间隔大于 500 ms ，可以执行
          flag = true;
        }
        pasteTime = now;
        return flag;
      }

      // 粘贴文字
      $textElem.on('paste', (e) => {
            if (UA.isIE()) {
                return;
            } else {
                // 阻止默认行为，使用 execCommand 的粘贴命令
                e.preventDefault();
            }

            // 粘贴图片和文本，只能同时使用一个
            if (!canDo()) {
                return;
            }

            // 获取粘贴的文字
            var pasteHtml = getPasteHtml(e, pasteFilterStyle);
            var pasteText = getPasteText(e);
            pasteText = pasteText.replace(/\n/gm, '<br>');

            // 自定义处理粘贴的内容
            if (pasteTextHandle && typeof pasteTextHandle === 'function') {
                pasteHtml = '' + (pasteTextHandle(pasteHtml) || '');
                pasteText = '' + (pasteTextHandle(pasteText) || '');
            }

            var $selectionElem = editor.selection.getSelectionContainerElem();
            if (!$selectionElem) {
                return;
            }
            var nodeName = $selectionElem.getNodeName();

            // code 中只能粘贴纯文本
            if (nodeName === 'CODE' || nodeName === 'PRE') {
                editor.cmd.do('insertHTML', '<p>' + pasteText + '</p>');
                return;
            }

            // 先放开注释，有问题再追查 ————
            // // 表格中忽略，可能会出现异常问题
            // if (nodeName === 'TD' || nodeName === 'TH') {
            //     return
            // }

            if (!pasteHtml) {
                return;
            }
            try {
                // firefox 中，获取的 pasteHtml 可能是没有 <ul> 包裹的 <li>
                // 因此执行 insertHTML 会报错
                editor.cmd.do('insertHTML', pasteHtml);
            } catch (ex) {
                // 此时使用 pasteText 来兼容一下
                editor.cmd.do('insertHTML', '<p>' + pasteText + '</p>');
            }
        });

      // 粘贴图片
      $textElem.on('paste', function (e) {
            if (UA.isIE()) {
                return;
            } 
                e.preventDefault();
            

            // 粘贴图片和文本，只能同时使用一个
            if (!canDo()) {
                return;
            }

            // 获取粘贴的图片
            var pasteFiles = getPasteImgs(e);
            if (!pasteFiles || !pasteFiles.length) {
                return;
            }

            // 获取当前的元素
            var $selectionElem = editor.selection.getSelectionContainerElem();
            if (!$selectionElem) {
                return;
            }
            var nodeName = $selectionElem.getNodeName();

            // code 中粘贴忽略
            if (nodeName === 'CODE' || nodeName === 'PRE') {
                return;
            }

            // 上传图片
            var uploadImg = editor.uploadImg;
            uploadImg.uploadImg(pasteFiles);
        });
    },

    // tab 特殊处理
    _tabHandle: function _tabHandle() {
      let editor = this.editor;
      let $textElem = editor.$textElem;

      $textElem.on('keydown', (e) => {
            if (e.keyCode !== 9) {
                return;
            }
            if (!editor.cmd.queryCommandSupported('insertHTML')) {
                // 必须原生支持 insertHTML 命令
                return;
            }
            var $selectionElem = editor.selection.getSelectionContainerElem();
            if (!$selectionElem) {
                return;
            }
            var $parentElem = $selectionElem.parent();
            var selectionNodeName = $selectionElem.getNodeName();
            var parentNodeName = $parentElem.getNodeName();

            if (selectionNodeName === 'CODE' && parentNodeName === 'PRE') {
                // <pre><code> 里面
                editor.cmd.do('insertHTML', '    ');
            } else {
                // 普通文字
                editor.cmd.do('insertHTML', '&nbsp;&nbsp;&nbsp;&nbsp;');
            }

            e.preventDefault();
        });
    },

    // img 点击
    _imgHandle: function _imgHandle() {
      let editor = this.editor;
      let $textElem = editor.$textElem;

      // 为图片增加 selected 样式
      $textElem.on('click', 'img', function (e) {
        let img = this;
        let $img = $(img);

        if ($img.attr('data-w-e') === '1') {
          // 是表情图片，忽略
          return;
        }

        // 记录当前点击过的图片
        editor._selectedImg = $img;

        // 修改选区并 restore ，防止用户此时点击退格键，会删除其他内容
        editor.selection.createRangeByElem($img);
        editor.selection.restoreSelection();
      });

      // 去掉图片的 selected 样式
      $textElem.on('click  keyup', (e) => {
            if (e.target.matches('img')) {
                // 点击的是图片，忽略
                return;
            }
            // 删除记录
            editor._selectedImg = null;
        });
    },

    // 拖拽事件
    _dragHandle: function _dragHandle() {
      let editor = this.editor;

      // 禁用 document 拖拽事件
      let $document = $(document);
      $document.on('dragleave drop dragenter dragover', (e) => {
            e.preventDefault();
        });

      // 添加编辑区域拖拽事件
      let $textElem = editor.$textElem;
      $textElem.on('drop', (e) => {
            e.preventDefault();
            var files = e.dataTransfer && e.dataTransfer.files;
            if (!files || !files.length) {
                return;
            }

            // 上传图片
            var uploadImg = editor.uploadImg;
            uploadImg.uploadImg(files);
        });
    }
  };

  /*
    命令，封装 document.execCommand
*/

  // 构造函数
  function Command(editor) {
    this.editor = editor;
  }

  // 修改原型
  Command.prototype = {
    constructor: Command,

    // 执行命令
    do: function _do(name, value) {
      let editor = this.editor;

      // 如果无选区，忽略
      if (!editor.selection.getRange()) {
        return;
      }

      // 恢复选取
      editor.selection.restoreSelection();

      // 执行
      let _name = `_${  name}`;
      if (this[_name]) {
        // 有自定义事件
        this[_name](value);
      } else {
        // 默认 command
        this._execCommand(name, value);
      }

      // 修改菜单状态
      editor.menus.changeActive();

      // 最后，恢复选取保证光标在原来的位置闪烁
      editor.selection.saveRange();
      editor.selection.restoreSelection();

      // 触发 onchange
      editor.change && editor.change();
    },

    // 自定义 insertHTML 事件
    _insertHTML: function _insertHTML(html) {
      let editor = this.editor;
      let range = editor.selection.getRange();

      if (this.queryCommandSupported('insertHTML')) {
        // W3C
        this._execCommand('insertHTML', html);
      } else if (range.insertNode) {
        // IE
        range.deleteContents();
        range.insertNode($(html)[0]);
      } else if (range.pasteHTML) {
        // IE <= 10
        range.pasteHTML(html);
      }
    },

    // 插入 elem
    _insertElem: function _insertElem($elem) {
      let editor = this.editor;
      let range = editor.selection.getRange();

      if (range.insertNode) {
        range.deleteContents();
        range.insertNode($elem[0]);
      }
    },

    // 封装 execCommand
    _execCommand: function _execCommand(name, value) {
      document.execCommand(name, false, value);
    },

    // 封装 document.queryCommandValue
    queryCommandValue: function queryCommandValue(name) {
      return document.queryCommandValue(name);
    },

    // 封装 document.queryCommandState
    queryCommandState: function queryCommandState(name) {
      return document.queryCommandState(name);
    },

    // 封装 document.queryCommandSupported
    queryCommandSupported: function queryCommandSupported(name) {
      return document.queryCommandSupported(name);
    }
  };

  /*
    selection range API
*/

  // 构造函数
  function API(editor) {
    this.editor = editor;
    this._currentRange = null;
  }

  // 修改原型
  API.prototype = {
    constructor: API,

    // 获取 range 对象
    getRange: function getRange() {
      return this._currentRange;
    },

    // 保存选区
    saveRange: function saveRange(_range) {
      if (_range) {
        // 保存已有选区
        this._currentRange = _range;
        return;
      }

      // 获取当前的选区
      let selection = window.getSelection();
      if (selection.rangeCount === 0) {
        return;
      }
      let range = selection.getRangeAt(0);

      // 判断选区内容是否在编辑内容之内
      let $containerElem = this.getSelectionContainerElem(range);
      if (!$containerElem) {
        return;
      }
      let editor = this.editor;
      let $textElem = editor.$textElem;
      if ($textElem.isContain($containerElem)) {
        // 是编辑内容之内的
        this._currentRange = range;
      }
    },

    // 折叠选区
    collapseRange: function collapseRange(toStart) {
      if (toStart == null) {
        // 默认为 false
        toStart = false;
      }
      let range = this._currentRange;
      if (range) {
        range.collapse(toStart);
      }
    },

    // 选中区域的文字
    getSelectionText: function getSelectionText() {
        var range = this._currentRange;
        if (range) {
            return this._currentRange.toString();
        } 
            return '';
        
    },

    // 选区的 $Elem
    getSelectionContainerElem: function getSelectionContainerElem(range) {
      range = range || this._currentRange;
      let elem = void 0;
      if (range) {
        elem = range.commonAncestorContainer;
        return $(elem.nodeType === 1 ? elem : elem.parentNode);
      }
    },
    getSelectionStartElem: function getSelectionStartElem(range) {
      range = range || this._currentRange;
      let elem = void 0;
      if (range) {
        elem = range.startContainer;
        return $(elem.nodeType === 1 ? elem : elem.parentNode);
      }
    },
    getSelectionEndElem: function getSelectionEndElem(range) {
      range = range || this._currentRange;
      let elem = void 0;
      if (range) {
        elem = range.endContainer;
        return $(elem.nodeType === 1 ? elem : elem.parentNode);
      }
    },

    // 选区是否为空
    isSelectionEmpty: function isSelectionEmpty() {
      let range = this._currentRange;
      if (range && range.startContainer) {
        if (range.startContainer === range.endContainer) {
          if (range.startOffset === range.endOffset) {
            return true;
          }
        }
      }
      return false;
    },

    // 恢复选区
    restoreSelection: function restoreSelection() {
      let selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(this._currentRange);
    },

    // 创建一个空白（即 &#8203 字符）选区
    createEmptyRange: function createEmptyRange() {
      let editor = this.editor;
      let range = this.getRange();
      let $elem = void 0;

      if (!range) {
        // 当前无 range
        return;
      }
      if (!this.isSelectionEmpty()) {
        // 当前选区必须没有内容才可以
        return;
      }

      try {
        // 目前只支持 webkit 内核
        if (UA.isWebkit()) {
          // 插入 &#8203
          editor.cmd.do('insertHTML', '&#8203;');
          // 修改 offset 位置
          range.setEnd(range.endContainer, range.endOffset + 1);
          // 存储
          this.saveRange(range);
        } else {
          $elem = $('<strong>&#8203;</strong>');
          editor.cmd.do('insertElem', $elem);
          this.createRangeByElem($elem, true);
        }
      } catch (ex) {
        // 部分情况下会报错，兼容一下
      }
    },

    // 根据 $Elem 设置选区
    createRangeByElem: function createRangeByElem($elem, toStart, isContent) {
      // $elem - 经过封装的 elem
      // toStart - true 开始位置，false 结束位置
      // isContent - 是否选中Elem的内容
      if (!$elem.length) {
        return;
      }

      let elem = $elem[0];
      let range = document.createRange();

      if (isContent) {
        range.selectNodeContents(elem);
      } else {
        range.selectNode(elem);
      }

      if (typeof toStart === 'boolean') {
        range.collapse(toStart);
      }

      // 存储 range
      this.saveRange(range);
    }
  };

  /*
    上传进度条
*/

  function Progress(editor) {
    this.editor = editor;
    this._time = 0;
    this._isShow = false;
    this._isRender = false;
    this._timeoutId = 0;
    this.$textContainer = editor.$textContainerElem;
    this.$bar = $('<div class="w-e-progress"></div>');
  }

  Progress.prototype = {
    constructor: Progress,

    show: function show(progress) {
      let _this = this;

      // 状态处理
      if (this._isShow) {
        return;
      }
      this._isShow = true;

      // 渲染
      let $bar = this.$bar;
      if (!this._isRender) {
        let $textContainer = this.$textContainer;
        $textContainer.append($bar);
      } else {
        this._isRender = true;
      }

      // 改变进度（节流，100ms 渲染一次）
      if (Date.now() - this._time > 100) {
        if (progress <= 1) {
          $bar.css('width', `${progress * 100  }%`);
          this._time = Date.now();
        }
      }

      // 隐藏
      let timeoutId = this._timeoutId;
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
            _this._hide();
        }, 500);
    },

    _hide: function _hide() {
      let $bar = this.$bar;
      $bar.remove();

      // 修改状态
      this._time = 0;
      this._isShow = false;
      this._isRender = false;
    }
  };

  let _typeof = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
  };

  /*
    上传图片
*/

  // 构造函数
  function UploadImg(editor) {
    this.editor = editor;
  }

  // 原型
  UploadImg.prototype = {
    constructor: UploadImg,

    // 根据 debug 弹出不同的信息
    _alert: function _alert(alertInfo, debugInfo) {
      let editor = this.editor;
      let debug = editor.config.debug;
      let customAlert = editor.config.customAlert;

      if (debug) {
        throw new Error(`wangEditor: ${  debugInfo || alertInfo}`);
      } else if (customAlert && typeof customAlert === 'function') {
                customAlert(alertInfo);
            } else {
                alert(alertInfo);
            }
    },

    // 根据链接插入图片
    insertLinkImg: function insertLinkImg(link) {
      let _this2 = this;

      if (!link) {
        return;
      }
      let editor = this.editor;
      let config = editor.config;

      // 校验格式
      let linkImgCheck = config.linkImgCheck;
      let checkResult = void 0;
      if (linkImgCheck && typeof linkImgCheck === 'function') {
        checkResult = linkImgCheck(link);
        if (typeof checkResult === 'string') {
          // 校验失败，提示信息
          alert(checkResult);
          return;
        }
      }

      editor.cmd.do('insertHTML', `<p style="text-align:center"><img src="${  link  }" style="max-width:100%;"/></p>`);

      // 验证图片 url 是否有效，无效的话给出提示
      let img = document.createElement('img');
      img.onload = function () {
        let callback = config.linkImgCallback;
        if (callback && typeof callback === 'function') {
          callback(link);
        }

        img = null;
      };
      img.onerror = function () {
            img = null;
            // 无法成功下载图片
            _this2._alert(i18n.t('wangEditor.insertPictureError'), 'wangEditor: \u63D2\u5165\u56FE\u7247\u51FA\u9519\uFF0C\u56FE\u7247\u94FE\u63A5\u662F "' + link + '"\uFF0C\u4E0B\u8F7D\u8BE5\u94FE\u63A5\u5931\u8D25');
            
        };
      img.onabort = function () {
        img = null;
      };
      img.src = link;
    },

    // 上传图片
    uploadImg: function uploadImg(files) {
      let _this3 = this;

      if (!files || !files.length) {
        return;
      }

      // ------------------------------ 获取配置信息 ------------------------------
      let editor = this.editor;
      let config = editor.config;
      let uploadImgServer = config.uploadImgServer;
      let uploadImgShowBase64 = config.uploadImgShowBase64;

      let maxSize = config.uploadImgMaxSize;
      let maxSizeM = maxSize / 1000 / 1000;
      let maxLength = config.uploadImgMaxLength || 10000;
      let uploadFileName = config.uploadFileName || '';
      let uploadImgParams = config.uploadImgParams || {};
      let uploadImgParamsWithUrl = config.uploadImgParamsWithUrl;
      let uploadImgHeaders = config.uploadImgHeaders || {};
      let hooks = config.uploadImgHooks || {};
      let timeout = config.uploadImgTimeout || 3000;
      let withCredentials = config.withCredentials;
      if (withCredentials == null) {
        withCredentials = false;
      }
      let customUploadImg = config.customUploadImg;

      if (!customUploadImg) {
        // 没有 customUploadImg 的情况下，需要如下两个配置才能继续进行图片上传
        if (!uploadImgServer && !uploadImgShowBase64) {
          return;
        }
      }

      // ------------------------------ 验证文件信息 ------------------------------
      let resultFiles = [];
      let errInfo = [];
      arrForEach(files, (file) => {
            var name = file.name;
            var size = file.size;

            // chrome 低版本 name === undefined
            if (!name || !size) {
                return;
            }

            if (/\.(jpg|jpeg|png|bmp|gif)$/i.test(name) === false) {
                // 后缀名不合法，不是图片
                errInfo.push('\u3010' + name + '\u3011\u4E0D\u662F\u56FE\u7247');
                return;
            }
            if (maxSize < size) {
                // 上传图片过大
                errInfo.push('\u3010' + name + '\u3011\u5927\u4E8E ' + maxSizeM + 'M');
                return;
            }

            // 验证通过的加入结果列表
            resultFiles.push(file);
        });
      // 抛出验证信息
      if (errInfo.length) {
        this._alert(`${i18n.t('wangEditor.imageVerificationFailed')}: \n${  errInfo.join('\n')}`);
        return;
      }
      if (resultFiles.length > maxLength) {
        this._alert(i18n.t('wangEditor.uploadLimitAtATime',{total: maxLength}));
        return;
      }

      // ------------------------------ 自定义上传 ------------------------------
      if (customUploadImg && typeof customUploadImg === 'function') {
        customUploadImg(resultFiles, this.insertLinkImg.bind(this));

        // 阻止以下代码执行
        return;
      }

      // 添加图片数据
      let formdata = new FormData();
      arrForEach(resultFiles, (file) => {
            var name = uploadFileName || file.name;
            formdata.append(name, file);
        });

      // ------------------------------ 上传图片 ------------------------------
      if (uploadImgServer && typeof uploadImgServer === 'string') {
        // 添加参数
        let uploadImgServerArr = uploadImgServer.split('#');
        uploadImgServer = uploadImgServerArr[0];
        let uploadImgServerHash = uploadImgServerArr[1] || '';
        objForEach(uploadImgParams, (key, val) => {
                val = encodeURIComponent(val);

                // 第一，将参数拼接到 url 中
                if (uploadImgParamsWithUrl) {
                    if (uploadImgServer.indexOf('?') > 0) {
                        uploadImgServer += '&';
                    } else {
                        uploadImgServer += '?';
                    }
                    uploadImgServer = uploadImgServer + key + '=' + val;
                }

                // 第二，将参数添加到 formdata 中
                formdata.append(key, val);
            });
        if (uploadImgServerHash) {
          uploadImgServer += `#${  uploadImgServerHash}`;
        }

        // 定义 xhr
        let xhr = new XMLHttpRequest();
        xhr.open('POST', uploadImgServer);

        // 设置超时
        xhr.timeout = timeout;
        xhr.ontimeout = function () {
          // hook - timeout
          if (hooks.timeout && typeof hooks.timeout === 'function') {
            hooks.timeout(xhr, editor);
          }

          _this3._alert(i18n.t('wangEditor.uploadPictureTimeOut'));
        };

        // 监控 progress
        if (xhr.upload) {
          xhr.upload.onprogress = function (e) {
            let percent = void 0;
            // 进度条
            let progressBar = new Progress(editor);
            if (e.lengthComputable) {
              percent = e.loaded / e.total;
              progressBar.show(percent);
            }
          };
        }

        // 返回数据
        xhr.onreadystatechange = function () {
          let result = void 0;
          if (xhr.readyState === 4) {
            if (xhr.status < 200 || xhr.status >= 300) {
              // hook - error
              if (hooks.error && typeof hooks.error === 'function') {
                hooks.error(xhr, editor);
              }

              // xhr 返回状态错误
              _this3._alert(i18n.t('wangEditor.uploadImageError'), `\u4E0A\u4F20\u56FE\u7247\u53D1\u751F\u9519\u8BEF\uFF0C\u670D\u52A1\u5668\u8FD4\u56DE\u72B6\u6001\u662F ${  xhr.status}`);
              return;
            }

            result = xhr.responseText;
            if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) !== 'object') {
              try {
                result = JSON.parse(result);
              } catch (ex) {
                // hook - fail
                if (hooks.fail && typeof hooks.fail === 'function') {
                  hooks.fail(xhr, editor, result);
                }

                _this3._alert(i18n.t('wangEditor.uploadPictureFailed'), `${i18n.t('wangEditor.uploadErrorMsg')}: ${  result}`);
                return;
              }
            }
            if (!hooks.customInsert && result.errno != '0') {
              // hook - fail
              if (hooks.fail && typeof hooks.fail === 'function') {
                hooks.fail(xhr, editor, result);
              }

              // 数据错误
              _this3._alert(i18n.t('wangEditor.uploadPictureFailed'), `${i18n.t('wangEditor.uploadErrorMsg')} errno=${  result.errno}`);
            } else {
              if (hooks.customInsert && typeof hooks.customInsert === 'function') {
                // 使用者自定义插入方法
                hooks.customInsert(_this3.insertLinkImg.bind(_this3), result, editor);
              } else {
                // 将图片插入编辑器
                let data = result.data || [];
                data.forEach((link) => {
                                _this3.insertLinkImg(link);
                            });
              }

              // hook - success
              if (hooks.success && typeof hooks.success === 'function') {
                hooks.success(xhr, editor, result);
              }
            }
          }
        };

        // hook - before
        if (hooks.before && typeof hooks.before === 'function') {
          let beforeResult = hooks.before(xhr, editor, resultFiles);
          if (beforeResult && (typeof beforeResult === 'undefined' ? 'undefined' : _typeof(beforeResult)) === 'object') {
            if (beforeResult.prevent) {
              // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
              this._alert(beforeResult.msg);
              return;
            }
          }
        }

        // 自定义 headers
        objForEach(uploadImgHeaders, (key, val) => {
                xhr.setRequestHeader(key, val);
            });

        // 跨域传 cookie
        xhr.withCredentials = withCredentials;

        // 发送请求
        xhr.send(formdata);

        // 注意，要 return 。不去操作接下来的 base64 显示方式
        return;
      }

      // ------------------------------ 显示 base64 格式 ------------------------------
      if (uploadImgShowBase64) {
        arrForEach(files, (file) => {
                var _this = _this3;
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    _this.insertLinkImg(this.result);
                };
            });
      }
    }
  };

  /*
    编辑器构造函数
*/

  // id，累加
  let editorId = 1;

  // 构造函数
  function Editor(toolbarSelector, textSelector) {
    if (toolbarSelector == null) {
      // 没有传入任何参数，报错
      throw new Error(i18n.t('wangEditor.initParamsError'));
    }
    // id，用以区分单个页面不同的编辑器对象
    this.id = `wangEditor-${  editorId++}`;

    this.toolbarSelector = toolbarSelector;
    this.textSelector = textSelector;

    // 自定义配置
    this.customConfig = {};
  }

  // 修改原型
  Editor.prototype = {
    constructor: Editor,

    // 初始化配置
    _initConfig: function _initConfig() {
      // _config 是默认配置，this.customConfig 是用户自定义配置，将它们 merge 之后再赋值
      let target = {};
      this.config = Object.assign(target, config, this.customConfig);

      // 将语言配置，生成正则表达式
      let langConfig = this.config.lang || {};
      let langArgs = [];
      objForEach(langConfig, (key, val) => {
            // key 即需要生成正则表达式的规则，如“插入链接”
            // val 即需要被替换成的语言，如“insert link”
            langArgs.push({
                reg: new RegExp(key, 'img'),
                val: val

            });
        });
      this.config.langArgs = langArgs;
    },

    // 初始化 DOM
    _initDom: function _initDom() {
      let _this = this;

      let toolbarSelector = this.toolbarSelector;
      let $toolbarSelector = $(toolbarSelector);
      let textSelector = this.textSelector;

      let config$$1 = this.config;
      let zIndex = config$$1.zIndex;

      // 定义变量
      let $toolbarElem = void 0;
            var $textContainerElem = void 0;
            var $textElem = void 0;
            var $children = void 0;

      if (textSelector == null) {
        // 只传入一个参数，即是容器的选择器或元素，toolbar 和 text 的元素自行创建
        $toolbarElem = $('<div></div>');
        $textContainerElem = $('<div></div>');

        // 将编辑器区域原有的内容，暂存起来
        $children = $toolbarSelector.children();

        // 添加到 DOM 结构中
        $toolbarSelector.append($toolbarElem).append($textContainerElem);

        // 自行创建的，需要配置默认的样式
        $toolbarElem.css('background-color', '#f1f1f1').css('border', '1px solid #ccc');
        $textContainerElem.css('border', '1px solid #ccc').css('border-top', 'none').css('height', '200px');
      } else {
        // toolbar 和 text 的选择器都有值，记录属性
        $toolbarElem = $toolbarSelector;
        $textContainerElem = $(textSelector);
        // 将编辑器区域原有的内容，暂存起来
        $children = $textContainerElem.children();
      }

      // 编辑区域
      $textElem = $('<div></div>');
      $textElem.attr('contenteditable', 'true').css('width', '100%').css('height', '100%');

      // 初始化编辑区域内容
      if ($children && $children.length) {
        $textElem.append($children);
      } else {
        $textElem.append($('<p><br></p>'));
      }

      // 编辑区域加入DOM
      $textContainerElem.append($textElem);

      // 设置通用的 class
      $toolbarElem.addClass('w-e-toolbar');
      $textContainerElem.addClass('w-e-text-container');
      $textContainerElem.css('z-index', zIndex);
      $textElem.addClass('w-e-text');

      // 添加 ID
      let toolbarElemId = getRandom('toolbar-elem');
      $toolbarElem.attr('id', toolbarElemId);
      let textElemId = getRandom('text-elem');
      $textElem.attr('id', textElemId);

      // 记录属性
      this.$toolbarElem = $toolbarElem;
      this.$textContainerElem = $textContainerElem;
      this.$textElem = $textElem;
      this.toolbarElemId = toolbarElemId;
      this.textElemId = textElemId;

      // 绑定 onchange
      $textContainerElem.on('click keyup', () => {
            _this.change && _this.change();
        });
      $toolbarElem.on('click', function () {
        this.change && this.change();
      });

      // 绑定 onfocus 与 onblur 事件
      if (config$$1.onfocus || config$$1.onblur) {
        // 当前编辑器是否是焦点状态
        this.isFocus = false;

        $(document).on('click', (e) => {
                //判断当前点击元素是否在编辑器内
                var isChild = $toolbarSelector.isContain($(e.target));

                if (!isChild) {
                    if (_this.isFocus) {
                        _this.onblur && _this.onblur();
                    }
                    _this.isFocus = false;
                } else {
                    if (!_this.isFocus) {
                        _this.onfocus && _this.onfocus();
                    }
                    _this.isFocus = true;
                }
            });
      }
    },

    // 封装 command
    _initCommand: function _initCommand() {
      this.cmd = new Command(this);
    },

    // 封装 selection range API
    _initSelectionAPI: function _initSelectionAPI() {
      this.selection = new API(this);
    },

    // 添加图片上传
    _initUploadImg: function _initUploadImg() {
      this.uploadImg = new UploadImg(this);
    },

    // 初始化菜单
    _initMenus: function _initMenus() {
      this.menus = new Menus(this);
      this.menus.init();
    },

    // 添加 text 区域
    _initText: function _initText() {
      this.txt = new Text(this);
      this.txt.init();
    },

    // 初始化选区，将光标定位到内容尾部
    initSelection: function initSelection(newLine) {
      let $textElem = this.$textElem;
      let $children = $textElem.children();
      if (!$children.length) {
        // 如果编辑器区域无内容，添加一个空行，重新设置选区
        $textElem.append($('<p><br></p>'));
        this.initSelection();
        return;
      }

      let $last = $children.last();

      if (newLine) {
        // 新增一个空行
        let html = $last.html().toLowerCase();
        let nodeName = $last.getNodeName();
        if (html !== '<br>' && html !== '<br\/>' || nodeName !== 'P') {
          // 最后一个元素不是 <p><br></p>，添加一个空行，重新设置选区
          $textElem.append($('<p><br></p>'));
          this.initSelection();
          return;
        }
      }

      this.selection.createRangeByElem($last, false, true);
      this.selection.restoreSelection();
    },

    // 绑定事件
    _bindEvent: function _bindEvent() {
      // -------- 绑定 onchange 事件 --------
      let onChangeTimeoutId = 0;
      let beforeChangeHtml = this.txt.html();
      let config$$1 = this.config;

      // onchange 触发延迟时间
      let onchangeTimeout = config$$1.onchangeTimeout;
      onchangeTimeout = parseInt(onchangeTimeout, 10);
      if (!onchangeTimeout || onchangeTimeout <= 0) {
        onchangeTimeout = 200;
      }

      let onchange = config$$1.onchange;
      if (onchange && typeof onchange === 'function') {
        // 触发 change 的有三个场景：
        // 1. $textContainerElem.on('click keyup')
        // 2. $toolbarElem.on('click')
        // 3. editor.cmd.do()
        this.change = function () {
          // 判断是否有变化
          let currentHtml = this.txt.html();

          if (currentHtml.length === beforeChangeHtml.length) {
            // 需要比较每一个字符
            if (currentHtml === beforeChangeHtml) {
              return;
            }
          }

          // 执行，使用节流
          if (onChangeTimeoutId) {
            clearTimeout(onChangeTimeoutId);
          }
          onChangeTimeoutId = setTimeout(() => {
                    // 触发配置的 onchange 函数
                    onchange(currentHtml);
                    beforeChangeHtml = currentHtml;
                }, onchangeTimeout);
        };
      }

      // -------- 绑定 onblur 事件 --------
      let onblur = config$$1.onblur;
      if (onblur && typeof onblur === 'function') {
        this.onblur = function () {
          let currentHtml = this.txt.html();
          onblur(currentHtml);
        };
      }

      // -------- 绑定 onfocus 事件 --------
      let onfocus = config$$1.onfocus;
      if (onfocus && typeof onfocus === 'function') {
        this.onfocus = function () {
          onfocus();
        };
      }
    },

    // 创建编辑器
    create: function create() {
      // 初始化配置信息
      this._initConfig();

      // 初始化 DOM
      this._initDom();

      // 封装 command API
      this._initCommand();

      // 封装 selection range API
      this._initSelectionAPI();

      // 添加 text
      this._initText();

      // 初始化菜单
      this._initMenus();

      // 添加 图片上传
      this._initUploadImg();

      // 初始化选区，将光标定位到内容尾部
      this.initSelection(true);

      // 绑定事件
      this._bindEvent();
    },

    // 解绑所有事件（暂时不对外开放）
    _offAllEvent: function _offAllEvent() {
      $.offAll();
    }
  };

  // 检验是否浏览器环境
  try {
    document;
  } catch (ex) {
    throw new Error(i18n.t('wangEditor.runInBrowser'));
  }

  // polyfill
  polyfill();

  // 这里的 `inlinecss` 将被替换成 css 代码的内容，详情可去 ./gulpfile.js 中搜索 `inlinecss` 关键字
  let inlinecss = '.w-e-toolbar,.w-e-text-container,.w-e-menu-panel {  padding: 0;  margin: 0;  box-sizing: border-box;}.w-e-toolbar *,.w-e-text-container *,.w-e-menu-panel * {  padding: 0;  margin: 0;  box-sizing: border-box;}.w-e-clear-fix:after {  content: "";  display: table;  clear: both;}.w-e-toolbar .w-e-droplist {  position: absolute;  left: 0;  top: 0;  background-color: #fff;  border: 1px solid #f1f1f1;  border-right-color: #ccc;  border-bottom-color: #ccc;}.w-e-toolbar .w-e-droplist .w-e-dp-title {  text-align: center;  color: #999;  line-height: 2;  border-bottom: 1px solid #f1f1f1;  font-size: 13px;}.w-e-toolbar .w-e-droplist ul.w-e-list {  list-style: none;  line-height: 1;}.w-e-toolbar .w-e-droplist ul.w-e-list li.w-e-item {  color: #333;  padding: 5px 0;}.w-e-toolbar .w-e-droplist ul.w-e-list li.w-e-item:hover {  background-color: #f1f1f1;}.w-e-toolbar .w-e-droplist ul.w-e-block {  list-style: none;  text-align: left;  padding: 5px;}.w-e-toolbar .w-e-droplist ul.w-e-block li.w-e-item {  display: inline-block;  *display: inline;  *zoom: 1;  padding: 3px 5px;}.w-e-toolbar .w-e-droplist ul.w-e-block li.w-e-item:hover {  background-color: #f1f1f1;}@font-face {  font-family: \'w-e-icon\';  src: url(data:application/x-font-woff;charset=utf-8;base64,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) format(\'truetype\');  font-weight: normal;  font-style: normal;}[class^="w-e-icon-"],[class*=" w-e-icon-"] {  /* use !important to prevent issues with browser extensions that change fonts */  font-family: \'w-e-icon\' !important;  speak: none;  font-style: normal;  font-weight: normal;  font-variant: normal;  text-transform: none;  line-height: 1;  /* Better Font Rendering =========== */  -webkit-font-smoothing: antialiased;  -moz-osx-font-smoothing: grayscale;}.w-e-icon-close:before {  content: "\\f00d";}.w-e-icon-upload2:before {  content: "\\e9c6";}.w-e-icon-trash-o:before {  content: "\\f014";}.w-e-icon-header:before {  content: "\\f1dc";}.w-e-icon-pencil2:before {  content: "\\e906";}.w-e-icon-paint-brush:before {  content: "\\f1fc";}.w-e-icon-image:before {  content: "\\e90d";}.w-e-icon-play:before {  content: "\\e912";}.w-e-icon-location:before {  content: "\\e947";}.w-e-icon-undo:before {  content: "\\e965";}.w-e-icon-redo:before {  content: "\\e966";}.w-e-icon-quotes-left:before {  content: "\\e977";}.w-e-icon-list-numbered:before {  content: "\\e9b9";}.w-e-icon-list2:before {  content: "\\e9bb";}.w-e-icon-link:before {  content: "\\e9cb";}.w-e-icon-happy:before {  content: "\\e9df";}.w-e-icon-bold:before {  content: "\\ea62";}.w-e-icon-underline:before {  content: "\\ea63";}.w-e-icon-italic:before {  content: "\\ea64";}.w-e-icon-strikethrough:before {  content: "\\ea65";}.w-e-icon-table2:before {  content: "\\ea71";}.w-e-icon-paragraph-left:before {  content: "\\ea77";}.w-e-icon-paragraph-center:before {  content: "\\ea78";}.w-e-icon-paragraph-right:before {  content: "\\ea79";}.w-e-icon-terminal:before {  content: "\\f120";}.w-e-icon-page-break:before {  content: "\\ea68";}.w-e-icon-cancel-circle:before {  content: "\\ea0d";}.w-e-toolbar {  display: -webkit-box;  display: -ms-flexbox;  display: flex;  padding: 0 5px;  /* 单个菜单 */}.w-e-toolbar .w-e-menu {  position: relative;  text-align: center;  padding: 5px 10px;  cursor: pointer;}.w-e-toolbar .w-e-menu i {  color: #999;}.w-e-toolbar .w-e-menu:hover i {  color: #333;}.w-e-toolbar .w-e-active i {  color: #1e88e5;}.w-e-toolbar .w-e-active:hover i {  color: #1e88e5;}.w-e-text-container .w-e-panel-container {  position: absolute;  top: 0;  left: 50%;  border: 1px solid #ccc;  border-top: 0;  box-shadow: 1px 1px 2px #ccc;  color: #333;  background-color: #fff;  /* 为 emotion panel 定制的样式 */  /* 上传图片的 panel 定制样式 */}.w-e-text-container .w-e-panel-container .w-e-panel-close {  position: absolute;  right: 0;  top: 0;  padding: 5px;  margin: 2px 5px 0 0;  cursor: pointer;  color: #999;}.w-e-text-container .w-e-panel-container .w-e-panel-close:hover {  color: #333;}.w-e-text-container .w-e-panel-container .w-e-panel-tab-title {  list-style: none;  display: -webkit-box;  display: -ms-flexbox;  display: flex;  font-size: 14px;  margin: 2px 10px 0 10px;  border-bottom: 1px solid #f1f1f1;}.w-e-text-container .w-e-panel-container .w-e-panel-tab-title .w-e-item {  padding: 3px 5px;  color: #999;  cursor: pointer;  margin: 0 3px;  position: relative;  top: 1px;}.w-e-text-container .w-e-panel-container .w-e-panel-tab-title .w-e-active {  color: #333;  border-bottom: 1px solid #333;  cursor: default;  font-weight: 700;}.w-e-text-container .w-e-panel-container .w-e-panel-tab-content {  padding: 10px 15px 10px 15px;  font-size: 16px;  /* 输入框的样式 */  /* 按钮的样式 */}.w-e-text-container .w-e-panel-container .w-e-panel-tab-content input:focus,.w-e-text-container .w-e-panel-container .w-e-panel-tab-content textarea:focus,.w-e-text-container .w-e-panel-container .w-e-panel-tab-content button:focus {  outline: none;}.w-e-text-container .w-e-panel-container .w-e-panel-tab-content textarea {  width: 100%;  border: 1px solid #ccc;  padding: 5px;}.w-e-text-container .w-e-panel-container .w-e-panel-tab-content textarea:focus {  border-color: #1e88e5;}.w-e-text-container .w-e-panel-container .w-e-panel-tab-content input[type=text] {  border: none;  border-bottom: 1px solid #ccc;  font-size: 14px;  height: 20px;  color: #333;  text-align: left;}.w-e-text-container .w-e-panel-container .w-e-panel-tab-content input[type=text].small {  width: 30px;  text-align: center;}.w-e-text-container .w-e-panel-container .w-e-panel-tab-content input[type=text].block {  display: block;  width: 100%;  margin: 10px 0;}.w-e-text-container .w-e-panel-container .w-e-panel-tab-content input[type=text]:focus {  border-bottom: 2px solid #1e88e5;}.w-e-text-container .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button {  font-size: 14px;  color: #1e88e5;  border: none;  padding: 5px 10px;  background-color: #fff;  cursor: pointer;  border-radius: 3px;}.w-e-text-container .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.left {  float: left;  margin-right: 10px;}.w-e-text-container .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.right {  float: right;  margin-left: 10px;}.w-e-text-container .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.gray {  color: #999;}.w-e-text-container .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.red {  color: #c24f4a;}.w-e-text-container .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button:hover {  background-color: #f1f1f1;}.w-e-text-container .w-e-panel-container .w-e-panel-tab-content .w-e-button-container:after {  content: "";  display: table;  clear: both;}.w-e-text-container .w-e-panel-container .w-e-emoticon-container .w-e-item {  cursor: pointer;  font-size: 18px;  padding: 0 3px;  display: inline-block;  *display: inline;  *zoom: 1;}.w-e-text-container .w-e-panel-container .w-e-up-img-container {  text-align: center;}.w-e-text-container .w-e-panel-container .w-e-up-img-container .w-e-up-btn {  display: inline-block;  *display: inline;  *zoom: 1;  color: #999;  cursor: pointer;  font-size: 60px;  line-height: 1;}.w-e-text-container .w-e-panel-container .w-e-up-img-container .w-e-up-btn:hover {  color: #333;}.w-e-text-container {  position: relative;}.w-e-text-container .w-e-progress {  position: absolute;  background-color: #1e88e5;  bottom: 0;  left: 0;  height: 1px;}.w-e-text {  padding: 0 10px;  overflow-y: scroll;}.w-e-text p,.w-e-text h1,.w-e-text h2,.w-e-text h3,.w-e-text h4,.w-e-text h5,.w-e-text table,.w-e-text pre {  margin: 10px 0;  line-height: 1.5;}.w-e-text ul,.w-e-text ol {  margin: 10px 0 10px 20px;}.w-e-text blockquote {  display: block;  border-left: 8px solid #d0e5f2;  padding: 5px 10px;  margin: 10px 0;  line-height: 1.4;  font-size: 100%;  background-color: #f1f1f1;}.w-e-text code {  display: inline-block;  *display: inline;  *zoom: 1;  background-color: #f1f1f1;  border-radius: 3px;  padding: 3px 5px;  margin: 0 3px;}.w-e-text pre code {  display: block;}.w-e-text table {  border-top: 1px solid #ccc;  border-left: 1px solid #ccc;}.w-e-text table td,.w-e-text table th {  border-bottom: 1px solid #ccc;  border-right: 1px solid #ccc;  padding: 3px 5px;}.w-e-text table th {  border-bottom: 2px solid #ccc;  text-align: center;}.w-e-text:focus {  outline: none;}.w-e-text img {  cursor: pointer;}.w-e-text img:hover {  box-shadow: 0 0 5px #333;}';

  // 将 css 代码添加到 <style> 中
  let style = document.createElement('style');
  style.type = 'text/css';
  style.innerHTML = inlinecss;
  document.getElementsByTagName('HEAD').item(0).appendChild(style);

  // 返回
  let index = window.wangEditor || Editor;

  return index;
})));
